/* globals Raven */
/* eslint moduleName:0 */

"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var slice = [].slice;
  var noScript = document.querySelector("[data-no-script]");
  if (noScript) {
    noScript.removeAttribute("data-no-script");
  }
  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp;

      // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace
      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      }

      // loop through the parts and create a nested namespace if necessary
      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i];

        // check if the current parent already has the namespace declared
        // if it isn't, then create it
        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        }

        // get a reference to the deepest element in the hierarchy so far
        parent = parent[part];
      }
      return parent;
    },
    isLocal: !!document.getElementById("js-server-local"),
    libraries: {
      gsap: {
        name: "gsap",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/gsap/gsap.min.js",
        cb: function cb() {
          DEBUG && console.log("GSAP");
        }
      },
      scrollTrigger: {
        name: "scrollTrigger",
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollTrigger.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollTrigger);
        }
      },
      scrollToPlugin: {
        name: "scrollTo",
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollToPlugin.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollToPlugin);
        }
      },
      smoothScroll: {
        name: "smoothScroll",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
      },
      slider: {
        name: "swiper",
        queue: [],
        started: false,
        loaded: false,
        style: "/assets/scripts/swiper/swiper.min.css",
        script: "/assets/scripts/swiper/swiper.min.js",
        cb: function cb() {
          Swiper.initedSliders = {};
        }
      }
    },
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;
        if (timeout == null) {
          timeout = 200;
        }
        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      throttler: function throttler(func, ms) {
        var isThrottled = false,
          savedArgs,
          savedThis;
        function wrapper() {
          if (isThrottled) {
            // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
          }
          func.apply(this, arguments); // (1)

          isThrottled = true;
          setTimeout(function () {
            isThrottled = false; // (3)
            if (savedArgs) {
              wrapper.apply(savedThis, savedArgs);
              savedArgs = savedThis = null;
            }
          }, ms);
        }
        return wrapper;
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0);
        // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())
        return scrTop;
      },
      getTime: function () {
        var res;
        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }
        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;
        if (precision == null) {
          precision = 2;
        }
        t0 = itsoftApp.utils.getTime(precision);
        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };
        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;
        for (k in ref) {
          module = ref[k];
          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }
        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();
        if (UA.indexOf("safari") != -1) {
          if (UA.indexOf("chrome") > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          itsoftApp.commonVars.viewWidth = document.documentElement.clientWidth;
        } else {
          itsoftApp.commonVars.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
        return itsoftApp.commonVars.viewWidth;
      },
      getViewportHeight: function getViewportHeight() {
        itsoftApp.commonVars.viewHeight = document.documentElement.clientHeight;
        return itsoftApp.commonVars.viewHeight;
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
        return itsoftApp.commonVars.headerHeight;
      },
      getDisclaimerHeight: function getDisclaimerHeight() {
        var disclaimer = document.querySelector(".disclaimer");
        return disclaimer && disclaimer.offsetHeight;
      },
      getCoords: function getCoords(el) {
        var box = el.getBoundingClientRect();
        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script");

      // If "fallback" url passed as second argument
      var args = Array.prototype.slice.call(arguments);
      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];
        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);
          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }
      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");
        if (typeof callback === "function") {
          callback();
        }
      };

      // IE
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        };

        // Normal browsers
      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }
        script.onload = cb;
      }
      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild;

      // Prepend styles in 'head' section
      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };
        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }
        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];
      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      }

      // Create a namespace
      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false;

      // Set dependencies
      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];
        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];
          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }
        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      }

      // Set initialization function and behavior
      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;
        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];
              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
              if (depModule.initialized) {
                continue;
              }
              depModule.init();
              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }
          t1 = itsoftApp.utils.getTime();
          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;
          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }
          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };
      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";
      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }
      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  };

  // Unit-tests for itsoftApp object
  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;
          testFunc = function testFunc() {
            console.log("test module init");
          };
          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;
          module = function module() {
            itsoftApp.createModule("testmodule");
          };
          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;
          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);
          testFunc = function testFunc() {
            return 1;
          };
          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }
  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined,
        viewWidth: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;
      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }
      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }
        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };
      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };
      itsoftApp.initAllModules();
      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }
          return results;
        }(), "color: " + dColor);
      }

      // Add benchmark div
      benchmarkDiv = document.getElementById("benchmark");
      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";
        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];
            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }
            return results;
          }() + "</small>";
        }

        // Add close button
        benchmarkCloseBtn = document.createElement("a");
        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };
        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        document.body.appendChild(benchmarkDiv);
      }

      // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.
      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;
        for (moduleName in initTimes) {
          time = initTimes[moduleName];
          if (moduleName === "all") {
            continue;
          }
          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        }

        //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0
        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      }

      // If unit tests library loaded, just load a file with tests
      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };
    if ("addEventListener" in document) {
      init();
    }
  };

  // Document ready event
  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false);

    // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;
  var AccordionItem = function AccordionItem(accordionItemElement, ACCORDION) {
    this.ACCORDION = ACCORDION;
    this.state = {
      opened: accordionItemElement.classList.contains("js-accordion-item--active")
    };
    this.accordionItemElement = accordionItemElement;
    this.accordionHeadElement = accordionItemElement.querySelector(".js-accordion-head");
    this.accordionContentElement = accordionItemElement.querySelector(".js-accordion-content");
    this.accordionText = accordionItemElement.querySelector(".js-accordion-text");
    this.preventNone = this.accordionHeadElement.hasAttribute("data-prevent-none");
    this.once = this.accordionHeadElement.hasAttribute("data-once");
    this.init();
    accordionItemElement.instance = this;
  };
  AccordionItem.prototype.init = function () {
    var ACCORDION_ITEM = this;
    this.openListener = ACCORDION_ITEM.onOpenTransitionEnd.bind(ACCORDION_ITEM);
    this.closeListener = ACCORDION_ITEM.onCloseTransitionEnd.bind(ACCORDION_ITEM);
    this.accordionHeadElement.addEventListener("click", ACCORDION_ITEM.onAccordionClick.bind(ACCORDION_ITEM));
  };
  AccordionItem.prototype.onAccordionClick = function (evt) {
    if (!this.preventNone) {
      /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
      evt.preventDefault();
    }

    /* если элемент аккордеона уже активен, скрываем его... */
    if (this.state.opened && this.ACCORDION.currentClosedItem == false) {
      if (this.ACCORDION.leastOne) {
        return;
      }
      this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
      this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
      this.ACCORDION.activeItem = "";
      this.closeAccordion();

      // if (this.ACCORDION.accordionType !== "any" && this.ACCORDION.activeItems.length === 0) {
      if (this.ACCORDION.activeItems.length === 0) {
        this.ACCORDION.state.opened = false;
        this.ACCORDION.accordion.classList.remove("js-accordion--active");
      }

      /* ...иначе показываем */
    } else {
      /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
      if (this.ACCORDION.accordionType !== "any") {
        /*...находим ранее активный элемент и скрываем его */

        if (this.ACCORDION.activeItem && this.ACCORDION.currentClosedItem == false) {
          this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
          this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
          this.ACCORDION.activeItem = "";
          this.ACCORDION.currentClosedItem.closeAccordion(); // Закрываем не текущий, а ранее активный элемент аккордеона
        }
      }

      /* показываем элемент, по которому был осуществлён клик */
      if (this.ACCORDION.currentOpenedItem == false) {
        this.ACCORDION.currentOpenedItem = this;
        this.openAccordion();
        if (!this.ACCORDION.state) {
          this.ACCORDION.state.opened = true;
          this.ACCORDION.accordion.classList.add("js-accordion--active");
        }
        if (this.ACCORDION.activeItems.length === this.ACCORDION.allItems.length && !this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = true;
        } else if (this.ACCORDION.activeItems.length < this.ACCORDION.allItems.length && this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = false;
        }
      }
    }

    /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */
    if (this.once) {
      this.accordionHeadElement.removeEventListener("click", this.onAccordionClick.bind(this));
    }
  };
  AccordionItem.prototype.closeAccordion = function () {
    var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var ACCORDION_ITEM = this;
    var closedText = this.accordionItemElement.getAttribute("data-closed-text"); // todo: Проверить работу
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionItemElement.classList.add("js-accordion-item--close-ready");
    this.accordionContentElement.style.height = height;
    if (closedText) {
      this.accordionText.textContent = closedText; // TODO: Проверить работу
    }
    if (getComputedStyle(this.accordionContentElement).transition && !now) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.closeListener);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION_ITEM.accordionContentElement.style.height = "0px";
        });
      });
    } else {
      ACCORDION_ITEM.accordionContentElement.style.height = "0px";
      this.onCloseTransitionEnd();
    }
  };
  AccordionItem.prototype.onCloseTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    this.accordionItemElement.classList.remove("js-accordion-item--active");
    this.accordionItemElement.classList.remove("js-accordion-item--close-ready");
    this.accordionContentElement.removeEventListener("transitionend", this.closeListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.currentClosedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      ScrollTrigger && ScrollTrigger.refresh();
    }
    this.state.opened = false;
  };
  AccordionItem.prototype.openAccordion = function () {
    var ACCORDION = this;
    var openedText = this.accordionItemElement.getAttribute("data-opened-text"); //todo: проверить

    /* если есть атрибут со значением, заменяем название элемента аакордеона во время открытия */
    if (openedText) {
      this.accordionText.textContent = openedText; // todo: проверить
    }
    this.accordionItemElement.classList.add("js-accordion-item--open-ready");
    this.accordionContentElement.style.height = "auto";
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionContentElement.style.height = "0px";
    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.openListener);

      /* чтобы была анимация открытия */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION.accordionContentElement.style.height = height;
        });
      });
    } else {
      ACCORDION.accordionContentElement.style.height = height;
      this.onOpenTransitionEnd();
    }
  };
  AccordionItem.prototype.onOpenTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
    //     чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
    this.accordionItemElement.classList.remove("js-accordion-item--open-ready");
    this.accordionItemElement.classList.add("js-accordion-item--active");
    this.accordionContentElement.removeEventListener("transitionend", this.openListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.activeItem = this;
    this.ACCORDION.activeItems.push(this);
    this.ACCORDION.currentOpenedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      ScrollTrigger && ScrollTrigger.refresh();
    }
    this.state.opened = true;
  };
  var Accordion = function Accordion(accordion) {
    this.state = {
      opened: false,
      openedAll: false
    }, this.accordion = accordion;
    this.accordionType = accordion.getAttribute("data-type");
    this.leastOne = accordion.hasAttribute("data-least-one");
    this.accordionItemElements = accordion.querySelectorAll(".js-accordion-item");
    this.accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
    this.allItems = [];
    this.activeItems = [];
    this.activeItem = "";
    this.activeAccordionContent = "";
    this.currentItem = "";
    this.currentOpenedItem = "";
    this.currentClosedItem = "";
    this.currentOpenedContent = "";
    this.currentClosedContent = "";
    this.heightUpdateFlag = accordion.hasAttribute("data-height-update");
    this.init();
  };
  Accordion.prototype.init = function () {
    /* Добавляет каждому элементу аккордеона обработчик события клика */
    var ACCORDION = this;
    Array.from(ACCORDION.accordionItemElements).forEach(function (el) {
      var accordionItem = new AccordionItem(el, ACCORDION);
      ACCORDION.allItems.push(accordionItem);
      if (accordionItem.state.opened) {
        ACCORDION.activeItems.push(accordionItem);

        // if (ACCORDION.accordionType !== "any") { // todo: Обязательно протестировать этот момент
        ACCORDION.activeItem = accordionItem;
        // }
      }
    });
    var debouncedUpdate = itsoftApp.utils.debouncer(function () {
      if (ACCORDION.accordion.classList.contains("js-accordion--active")) {
        Array.prototype.forEach.call(ACCORDION.activeItems, function (el) {
          var content = el.accordionContentElement;
          content.style.height = "auto";
          var height = content.clientHeight + "px";
          content.style.height = height;
        });
      }
    }, 500);
    itsoftApp.modules.windowResize.addEvent(function () {
      debouncedUpdate();
    });
  };
  module.callback = Accordion;
});
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
itsoftApp.createModule("animateTitle", function () {
  var module = this;
  var AnimateTitle = function AnimateTitle(target) {
    this.container = target;
    this.init();
  };
  AnimateTitle.prototype.init = function () {
    var THIS = this;

    // Повторный запуск разбирает уже обёрнутый <i> ещё раз и выводит
    // разметку текстом — заголовок может прийти из двух наблюдателей
    if (THIS.container.classList.contains("_show")) {
      return;
    }
    var arr = THIS.container.innerHTML.match(/<span.*?>.*?<\/span>|\S+/g);
    var newArr = [];
    var _iterator = _createForOfIteratorHelper(arr),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        var newEl = '';
        if (el.includes('<br>')) {
          newEl = el;
        } else {
          newEl = "<i>".concat(el, "</i>");
        }
        newArr.push(newEl);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var text = newArr.join(' ');
    THIS.container.innerHTML = text;
    THIS.container.classList.add('_show');
    var containerWithImageInTheEnd = THIS.container.closest('.js-animate-title-with-image');
    var parts = THIS.container.querySelectorAll('i');
    /* по умолчанию вся анимация укладывается в 550ms, и у длинного заголовка
       шаг между словами становится меньше 50ms — при переходе 0.6s кажется,
       что текст появился сразу. data-speed задаёт шаг вручную */
    var customSpeed = parseInt(THIS.container.dataset.speed, 10);
    var speed = customSpeed > 0 ? customSpeed : parts.length > 4 ? 550 / parts.length : 140;
    parts.forEach(function (el, index) {
      setTimeout(function () {
        el.classList.add('_show');
      }, (index + 1) * speed);
    });

    // логотип в конце заголовка — <img> или инлайн-<svg> (/cartilox-t/)
    var img = containerWithImageInTheEnd && containerWithImageInTheEnd.querySelector("img, svg");
    if (img) {
      var delay = (parts.length + 1) * speed;
      setTimeout(function () {
        img.classList.add('_show');
      }, delay);
    }
  };
  module.callback = AnimateTitle;
});
"use strict";

itsoftApp.createModule("buyingHover", function () {
  var module = this;
  var BuyingHover = function BuyingHover() {
    this.container = document.querySelector('.js-byuing-hover');
    this.links = this.container && this.container.querySelectorAll('a');
    this.classNames = {
      hover: '_hover'
    };
    if (this.container) {
      this.init();
    }
  };
  BuyingHover.prototype.init = function () {
    this.addListeners();
  };
  BuyingHover.prototype.addListeners = function () {
    this.addListenerMouseEnter();
    this.addListenerMouseLeave();
  };
  BuyingHover.prototype.addListenerMouseEnter = function () {
    for (var index = 0; index < this.links.length; index++) {
      var el = this.links[index];
      el.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    }
  };
  BuyingHover.prototype.addListenerMouseLeave = function () {
    for (var index = 0; index < this.links.length; index++) {
      var el = this.links[index];
      el.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  };
  BuyingHover.prototype.onMouseEnter = function (e) {
    e.target.classList.add(this.classNames.hover);
    this.container.classList.add(this.classNames.hover);
  };
  BuyingHover.prototype.onMouseLeave = function (e) {
    e.target.classList.remove(this.classNames.hover);
    this.container.classList.remove(this.classNames.hover);
  };
  new BuyingHover();
  module.callback = BuyingHover;
});
"use strict";

/**
 * Кликабельная карточка/баннер целиком (`data-card-link`).
 *
 * Клик по любому месту карточки ВНЕ её ссылок и кнопок срабатывает как клик
 * по главному элементу карточки. Главный элемент — по селектору из значения
 * атрибута (`data-card-link=".x"`), по умолчанию первый `a[href]`. Это может
 * быть и КНОПКА — например, триггер поп-апа (`data-card-link=".card__more"`;
 * на lymphomyosot так работала карточка продукта 09–13.10.2026, потом заказчик
 * вернул ссылку на страницу продукта, а поп-ап — только с плашки рейтинга).
 * Сами кнопки остаются обычными ссылками: клавиатура,
 * «открыть в новой вкладке», вторая кнопка карточки — всё работает как раньше.
 *
 * Почему не CSS-«растянутая ссылка» (::after кнопки на всю карточку): ей
 * нужен containing block = карточка, то есть у промежуточных обёрток надо
 * снять position. В баннерах проекта текст держится поверх абсолютной
 * картинки именно своим position: relative — без него он уходит под фото.
 *
 * Клик после свайпа в слайдере не срабатывает: Swiper гасит его на
 * контейнере в фазе перехвата раньше, чем событие дойдёт до карточки.
 * Выделение текста мышью — тоже не переход.
 */
itsoftApp.createModule("cardLink", function () {
  var module = this;
  var CARD = "[data-card-link]";
  var OWN_CONTROLS = "a, button, input, select, textarea, label, [role=button]";
  var primaryLink = function primaryLink(card) {
    var selector = card.getAttribute("data-card-link") || "a[href]";
    var link = card.querySelector(selector);
    if (!link) {
      return null;
    }

    // Кнопка (поп-ап, раскрытие) — главный элемент как есть; у ссылки
    // пустой адрес и заглушка "#" — без перехода.
    if (link.tagName !== "A") {
      return link;
    }
    var href = link.getAttribute("href");
    return href && href !== "#" ? link : null;
  };
  var onClick = function onClick(event) {
    if (event.defaultPrevented || event.button > 0) {
      return;
    }
    var target = event.target;
    var card = target && target.closest ? target.closest(CARD) : null;
    if (!card || target.closest(OWN_CONTROLS)) {
      return;
    }
    var selection = window.getSelection ? String(window.getSelection()) : "";
    if (selection) {
      return;
    }
    var link = primaryLink(card);
    if (!link) {
      return;
    }

    // Ctrl/Cmd/Shift-клик по карточке — как по ссылке: в новой вкладке.
    if (link.tagName === "A" && (event.ctrlKey || event.metaKey || event.shiftKey)) {
      window.open(link.href, "_blank", "noopener");
      return;
    }
    link.click(); // уважает target/rel самой ссылки; у кнопки — её обработчики
  };
  module.primaryLink = primaryLink;
  if (!document.querySelector(CARD)) {
    return false;
  }
  document.addEventListener("click", onClick);
});
"use strict";

/**
 * Разводящая → страница продукта без перезагрузки (заказчик, 23.10.2026:
 * «при клике на один из продуктов должна бесшовно открываться соответствующая
 * страница … со сменой URL через JS»).
 *
 * Как устроено:
 *   1. после загрузки разводящей обе страницы продуктов скачиваются заранее
 *      (fetch → DOMParser), а картинки их первого экрана — в кэш браузера;
 *   2. по клику секция разводящей становится fixed-слоем, а под ней
 *      `.l-content` подменяется контентом страницы продукта; адрес, title,
 *      description и canonical — из скачанного документа (history.pushState);
 *   3. модули переинициализируются на новом DOM (lazyLoading.refresh и т. д.);
 *   4. анимация 0.7s, cubic-bezier(0.71, 0.48, 0.28, 0.88): выбранная половина
 *      раскрывается на весь экран, вторая уезжает, тексты гаснут, пачка и нога
 *      перелетают на свои места в hero продукта (FLIP по коробкам —
 *      data-choose-box / data-choose-target-box(es); нога T — на кадр фона
 *      hero, по варианту кадра), затем слой тает
 *      (CSS: blocks/choose.styl);
 *   5. «назад» в браузере — обычная перезагрузка разводящей.
 *
 * HTML продуктов качается сразу при инициализации (картинки их первого экрана —
 * после load разводящей); клик до ответа ждёт его до WAIT мс (is-pending — тексты
 * гаснут), не дождался или нет prefetch (сеть, старый браузер) — обычный переход.
 * На Bitrix load приходит поздно (счётчики, jQuery с CDN, ядро), а страница продукта
 * отдаётся ~1 с — со стартом по load переход почти всегда шёл без анимации (23.10.2026).
 * Клик ДО загрузки самой сборки (defer-скрипт на Bitrix приходит после картинок и ядра)
 * ловит инлайн-скрипт в index.php: гасит тексты (is-pending), запоминает href в
 * window.chooseEarlyHref — здесь на старте переход доигрывается тем же ожиданием.
 */
itsoftApp.createModule("chooseProduct", function () {
  var module = this;
  var section = document.querySelector(".js-choose");
  if (!section) {
    return false;
  }
  var LEAVING_CLASS = "is-leaving";
  var FADING_CLASS = "is-fading";
  var TIME = 700;
  var FADE_DELAY = 350;
  var PENDING_CLASS = "is-pending";
  var WAIT = 3000; // сколько ждём prefetch после клика
  var MOBILE_QUERY = "(max-width: 1023px) and (orientation: portrait)"; // карточки стопкой (choose-wide в blocks/choose.styl)

  var supported = "fetch" in window && "DOMParser" in window && "pushState" in window.history && "Promise" in window;
  var pages = {};

  /* Картинки первого экрана продукта — в кэш, чтобы под слоем перехода был
     не пустой hero. Берём источники, подходящие текущему окну и плотности */
  var warmImages = function warmImages(doc) {
    var pictures = doc.querySelectorAll(".intro picture, .t-intro picture");
    var dpr = window.devicePixelRatio > 1.5 ? "2x" : "1x";
    Array.prototype.forEach.call(pictures, function (picture) {
      var sources = picture.querySelectorAll("source");
      var srcset = "";
      for (var i = 0; i < sources.length; i += 1) {
        var media = sources[i].getAttribute("media");
        if (!media || window.matchMedia(media).matches) {
          srcset = sources[i].getAttribute("srcset") || sources[i].getAttribute("data-srcset") || "";
          break;
        }
      }
      var candidates = srcset.split(",");
      var url = "";
      for (var _i = 0; _i < candidates.length; _i += 1) {
        var parts = candidates[_i].trim().split(/\s+/);
        if (!url || parts[1] === dpr) {
          url = parts[0];
        }
      }
      if (url && url.indexOf("data:") !== 0) {
        new Image().src = url;
      }
    });
  };
  var prefetch = function prefetch(href) {
    if (pages[href] || !supported) {
      return;
    }
    var page = {
      doc: null,
      promise: null
    };
    pages[href] = page;
    page.promise = window.fetch(href, {
      credentials: "same-origin"
    }).then(function (response) {
      return response.ok ? response.text() : Promise.reject(response.status);
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      if (!doc.querySelector(".l-content")) {
        throw new Error("no .l-content");
      }
      page.doc = doc;

      /* Картинки hero продукта — после загрузки разводящей, чтобы не мешать её картинкам */
      if (document.readyState === "complete") {
        warmImages(doc);
      } else {
        window.addEventListener("load", function () {
          warmImages(doc);
        });
      }
      return doc;
    })["catch"](function (err) {
      DEBUG && console.log("chooseProduct: prefetch " + href + " не удался — " + err);
      delete pages[href];
      return Promise.reject(err);
    });
    return page.promise;
  };

  /* ── Подмена документа ── */
  var swapHead = function swapHead(doc, href) {
    var title = doc.querySelector("title");
    var copyMeta = function copyMeta(selector, attr) {
      var next = doc.querySelector(selector);
      var current = document.querySelector(selector);
      if (!next) {
        return;
      }
      if (!current) {
        current = document.createElement(next.tagName);
        Array.prototype.forEach.call(next.attributes, function (a) {
          current.setAttribute(a.name, a.value);
        });
        document.head.appendChild(current);
      }
      current.setAttribute(attr, next.getAttribute(attr) || "");
    };
    if (title) {
      document.title = title.textContent;
    }
    copyMeta("meta[name='description']", "content");
    copyMeta("meta[property='og:title']", "content");
    copyMeta("meta[property='og:description']", "content");
    copyMeta("meta[property='og:url']", "content");
    copyMeta("link[rel='canonical']", "href");
    window.history.pushState({
      chooseProduct: true
    }, "", href);
  };
  var swapContent = function swapContent(doc) {
    var current = document.querySelector(".l-content");
    var next = document.importNode(doc.querySelector(".l-content"), true);
    current.parentNode.replaceChild(next, current);

    /* schema.org страницы продукта — стоит после контента, перед подвалом */
    Array.prototype.forEach.call(doc.querySelectorAll("script[type='application/ld+json']"), function (script) {
      var copy = document.createElement("script");
      copy.type = "application/ld+json";
      copy.textContent = script.textContent;
      next.parentNode.insertBefore(copy, next.nextSibling);
    });
    return next;
  };

  /* Модули, которые находят свои элементы на старте, — заново на новом DOM.
     Ленивые (слайдеры, аккордеон, заголовки, ролики) подхватят наблюдатели
     lazyLoading после refresh() */
  var reinitModules = function reinitModules(content) {
    var modules = itsoftApp.modules;
    if (modules.lazyLoading && modules.lazyLoading.refresh) {
      modules.lazyLoading.refresh();
    }
    if (modules.videoInView && modules.videoInView.refresh) {
      modules.videoInView.refresh();
    }
    ["tComponents", "parallax", "buyingHover", "draggable", "linksWithHash"].forEach(function (name) {
      if (modules[name] && typeof modules[name].init === "function") {
        modules[name].init();
      }
    });
    if (modules.scrollTo && modules.scrollTo.callback) {
      new modules.scrollTo.callback(); // eslint-disable-line no-new
    }

    /* Кнопки поп-апов: слушатели popups.js висят на старых кнопках */
    Array.prototype.forEach.call(content.querySelectorAll(".js-open-popup[data-popup-id]"), function (button) {
      button.addEventListener("click", function (evt) {
        var popup = document.getElementById(button.getAttribute("data-popup-id"));
        evt.preventDefault();
        if (popup && window.openEvent) {
          popup.dispatchEvent(window.openEvent);
        }
      });
    });
  };

  /* ── Анимация ── */
  var parseBox = function parseBox(value) {
    var parts = (value || "0,0,1,1").split(",").map(parseFloat);
    return {
      x: parts[0],
      y: parts[1],
      w: parts[2],
      h: parts[3]
    };
  };

  /* FLIP: элемент разводящей → на свою коробку в hero продукта. Коробки заданы
     долями картинок (data-choose-box / data-choose-target-box), совмещаем их,
     масштаб — по ширине коробки. У ноги коробка-цель зависит от кадра hero
     (data-choose-target-boxes — JSON по вариантам, вариант — по currentSrc) */
  var targetBoxFor = function targetBoxFor(el, target) {
    var boxes = el.getAttribute("data-choose-target-boxes");
    if (!boxes) {
      return parseBox(el.getAttribute("data-choose-target-box"));
    }
    var map = JSON.parse(boxes);
    var variant = heroVariant(target);
    return parseBox(map[variant] || map.base);
  };

  /* Какой кадр фона hero покажет браузер: по media источников <picture>, а не по
     currentSrc — в момент полёта картинка ещё может грузиться (планшет: без
     этого коробка бралась от базового кадра, нога улетала мимо) */
  var heroVariant = function heroVariant(img) {
    var picture = img.closest("picture");
    var src = "";
    if (picture) {
      var sources = picture.querySelectorAll("source[srcset]");
      for (var i = 0; i < sources.length; i++) {
        var media = sources[i].getAttribute("media");
        if (!media || window.matchMedia(media).matches) {
          src = sources[i].getAttribute("srcset");
          break;
        }
      }
    }
    src = (src || img.currentSrc || img.src || "").split(",")[0].split("/").pop();
    return /-mob/.test(src) ? "mob" : /-tab/.test(src) ? "tab" : /-xl/.test(src) ? "xl" : "base";
  };

  /* Коробка картинки-цели. У <img> с object-fit доли коробки считаются от самого
     отрисованного кадра, а не от бокса: фон hero Т на 1441…1919 — кадр xl (1920×852),
     бокс 853 в высоту, cover режет кадр по краям (на 1512 — по 205 с каждой стороны),
     и нога в hero остаётся 664 px при любой ширине. По боксу масштаб выходил 1.0,
     а место — мимо (заказчик, 24.10.2026). object-position в computed — проценты
     («50% 100%»), px — если так задано в CSS */
  var renderedRect = function renderedRect(target) {
    var box = target.getBoundingClientRect();
    if (target.tagName !== "IMG" || !target.naturalWidth || !target.naturalHeight) {
      return box;
    }
    var style = window.getComputedStyle(target);
    var fit = style.objectFit;
    if (fit !== "cover" && fit !== "contain") {
      return box;
    }
    var k = fit === "cover" ? Math.max(box.width / target.naturalWidth, box.height / target.naturalHeight) : Math.min(box.width / target.naturalWidth, box.height / target.naturalHeight);
    var w = target.naturalWidth * k;
    var h = target.naturalHeight * k;
    var pos = style.objectPosition.split(" ");
    var offset = function offset(value, free) {
      return /%$/.test(value) ? free * parseFloat(value) / 100 : parseFloat(value) || 0;
    };
    return {
      left: box.left + offset(pos[0], box.width - w),
      top: box.top + offset(pos[1] || "50%", box.height - h),
      width: w,
      height: h
    };
  };

  /* Кадр цели ещё не загружен — naturalWidth пуст и коробку не посчитать: ждём load,
     но не дольше WAIT_IMAGE (картинки hero греет prefetch, обычно они уже в кэше) */
  var WAIT_IMAGE = 400;
  var whenImageReady = function whenImageReady(target, callback) {
    if (!target || target.tagName !== "IMG" || target.complete) {
      callback();
      return;
    }
    var done = false;
    var finish = function finish() {
      if (!done) {
        done = true;
        callback();
      }
    };
    target.addEventListener("load", finish, {
      once: true
    });
    target.addEventListener("error", finish, {
      once: true
    });
    window.setTimeout(finish, WAIT_IMAGE);
  };
  var fly = function fly(el, target) {
    if (!el || !target) {
      return;
    }
    var from = el.getBoundingClientRect();
    var to = renderedRect(target);
    var fromBox = parseBox(el.getAttribute("data-choose-box"));
    var toBox = targetBoxFor(el, target);
    var fromW = from.width * fromBox.w;
    var toW = to.width * toBox.w;
    if (!fromW || !toW) {
      return;
    }
    var scale = toW / fromW;
    var fromX = from.left + from.width * fromBox.x;
    var fromY = from.top + from.height * fromBox.y;
    var toX = to.left + to.width * toBox.x;
    var toY = to.top + to.height * toBox.y;
    var dx = toX - fromX - from.width * fromBox.x * (scale - 1);
    var dy = toY - fromY - from.height * fromBox.y * (scale - 1);
    el.style.transform = "translate(" + dx.toFixed(2) + "px, " + dy.toFixed(2) + "px) scale(" + scale.toFixed(4) + ")";

    /* Клип по карточке открывается плавно: в none переход не анимируется */
    if (el.style.clipPath) {
      el.style.clipPath = "inset(0px 0px 0px 0px)";
      el.style.webkitClipPath = "inset(0px 0px 0px 0px)";
    }
  };

  /* Мобилка: карточки в потоке — перед анимацией закрепляем их в текущих
     координатах, выбранная раскрывается под шапку и до низа экрана */
  var freezeMobile = function freezeMobile(items, chosen) {
    var sectionRect = section.getBoundingClientRect();
    var headerHeight = parseFloat(window.getComputedStyle(section).paddingTop) || 0;
    var rects = Array.prototype.map.call(items, function (item) {
      return item.getBoundingClientRect();
    });
    Array.prototype.forEach.call(items, function (item, i) {
      item.style.position = "absolute";
      item.style.top = rects[i].top - sectionRect.top + "px";
      item.style.left = rects[i].left - sectionRect.left + "px";
      item.style.width = rects[i].width + "px";
      item.style.height = rects[i].height + "px";
      item.style.margin = "0";
    });
    return function () {
      chosen.style.top = headerHeight + "px";
      chosen.style.height = window.innerHeight - headerHeight + "px";
      chosen.style.borderRadius = "0";
    };
  };

  /* Пачка и нога выбранного продукта — из половины в сам слой перехода, в
     своих координатах: половина сейчас раскроется, и элемент внутри неё
     поехал бы и масштабировался вместе с ней (ширина задана долей половины).
     Нога в половине обрезана её краями (clip-path вслед за карточкой): после
     переноса край снимается плавно, вместе с полётом */
  var detach = function detach(item, el, zIndex, clipToItem) {
    if (!el) {
      return null;
    }
    var rect = el.getBoundingClientRect();
    var sectionRect = section.getBoundingClientRect();
    if (clipToItem) {
      var itemRect = item.getBoundingClientRect();
      var inset = [Math.max(0, itemRect.top - rect.top), Math.max(0, rect.right - itemRect.right), Math.max(0, rect.bottom - itemRect.bottom), Math.max(0, itemRect.left - rect.left)].map(function (v) {
        return v.toFixed(2) + "px";
      }).join(" ");
      el.style.clipPath = "inset(" + inset + ")";
      el.style.webkitClipPath = "inset(" + inset + ")";
    }
    el.style.top = rect.top - sectionRect.top + "px";
    el.style.left = rect.left - sectionRect.left + "px";
    el.style.width = rect.width + "px";
    el.style.height = rect.height + "px";
    el.style.margin = "0";
    el.style.bottom = "auto";
    el.style.right = "auto";
    el.style.zIndex = String(zIndex);
    /* FLIP считает сдвиг от левого верхнего угла — origin такой же */
    el.style.transformOrigin = "0 0";
    section.appendChild(el);
    return el;
  };
  var go = function go(item, href) {
    var doc = pages[href].doc;
    var key = item.getAttribute("data-choose");
    var items = section.querySelectorAll(".js-choose-item");
    var mobile = window.matchMedia(MOBILE_QUERY).matches;
    window.scrollTo(0, 0);
    var expandMobile = mobile ? freezeMobile(items, item) : null;
    var pack = detach(item, item.querySelector(".js-choose-pack"), 5, false);
    var figure = detach(item, item.querySelector(".js-choose-figure"), 4, true);

    /* Секция — поверх всего и вне .l-content, который сейчас заменим */
    section.style.height = section.offsetHeight + "px";
    document.body.appendChild(section);
    section.classList.add(LEAVING_CLASS);
    section.style.height = "";
    var content = swapContent(doc);
    swapHead(doc, href);
    reinitModules(content);

    /* Два кадра: новая страница разложена, можно мерить цели в hero */
    var packTarget = document.querySelector(item.getAttribute("data-choose-pack-target"));
    var figureTarget = document.querySelector(item.getAttribute("data-choose-figure-target"));
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        whenImageReady(figureTarget, function () {
          fly(pack, packTarget);
          fly(figure, figureTarget);
          if (expandMobile) {
            expandMobile();
          }
          section.classList.add(LEAVING_CLASS + "-" + key);
          section.classList.add(FADING_CLASS);
          window.setTimeout(function () {
            section.parentNode.removeChild(section);
          }, TIME + FADE_DELAY + 50);
        });
      });
    });
  };
  var onClick = function onClick(evt) {
    var item = evt.currentTarget;
    var href = item.getAttribute("href");
    if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
      return;
    }
    if (section.classList.contains(LEAVING_CLASS) || section.classList.contains(PENDING_CLASS)) {
      evt.preventDefault();
      return;
    }
    if (!pages[href] || !pages[href].promise) {
      return;
    }
    evt.preventDefault();
    if (pages[href].doc) {
      go(item, href);
      return;
    }
    waitAndGo(item, href);
  };

  /* Страница ещё качается: ждём её, но не дольше WAIT, иначе обычный переход */
  var waitAndGo = function waitAndGo(item, href) {
    section.classList.add(PENDING_CLASS);
    var timer = new Promise(function (resolve, reject) {
      window.setTimeout(function () {
        reject(new Error("timeout"));
      }, WAIT);
    });
    Promise.race([pages[href].promise, timer]).then(function () {
      go(item, href);
    })["catch"](function (err) {
      DEBUG && console.log("chooseProduct: " + href + " не дождались — " + err);
      window.location.href = href;
    });
  };
  var items = section.querySelectorAll(".js-choose-item");
  Array.prototype.forEach.call(items, function (item) {
    item.addEventListener("click", onClick);
  });
  if (supported) {
    /* HTML обеих страниц — сразу: это ~200 КБ текста, картинкам разводящей не
       мешает, а на Bitrix до load проходят секунды. Наведение / касание —
       повтор, если первая попытка не удалась */
    var retry = function retry(evt) {
      prefetch(evt.currentTarget.getAttribute("href"));
    };
    Array.prototype.forEach.call(items, function (item) {
      prefetch(item.getAttribute("href"));
      item.addEventListener("mouseenter", retry);
      item.addEventListener("touchstart", retry, {
        passive: true
      });
      item.addEventListener("focus", retry);
    });

    /* Клик случился до загрузки сборки (инлайн-скрипт index.php): доигрываем переход */
    if (window.chooseEarlyHref) {
      var earlyHref = window.chooseEarlyHref;
      var earlyItem = section.querySelector(".js-choose-item[href='" + earlyHref + "']");
      window.clearTimeout(window.chooseEarlyTimer);
      window.chooseEarlyHref = null;
      if (earlyItem && pages[earlyHref]) {
        waitAndGo(earlyItem, earlyHref);
      } else {
        window.location.href = earlyHref;
      }
    }
    window.addEventListener("popstate", function () {
      window.location.reload();
    });
  } else if (window.chooseEarlyHref) {
    window.clearTimeout(window.chooseEarlyTimer);
    window.location.href = window.chooseEarlyHref;
  }
  module.callback = {
    prefetch: prefetch,
    go: go
  };
  module.pages = pages;
});
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;
  var Cookie = function Cookie() {
    this.MAX_DATE = 2000000000;
    this.SESSION_DATE = 86400;
  };
  Cookie.prototype.setCookie = function (element, date) {
    var dAttrSave = element.getAttribute("data-save");
    var dAttrExpires = element.getAttribute("data-expires");
    if (date) {
      if (date == 'day') {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + this.SESSION_DATE;
      } else {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
      }
    } else if (dAttrExpires) {
      if (dAttrExpires === "max") {
        dAttrExpires = this.MAX_DATE;
      }
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + dAttrExpires;
    } else {
      document.cookie = dAttrSave + "=yes; path=/"; /* одна сессия */
    }
  };
  Cookie.prototype.getCookie = function (element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  Cookie.prototype.deleteCookie = function (element) {
    this.setCookie(element, {
      "max-age": -1
    }, "");
  };
  var cookieItem = new Cookie();
  module.setCookie = cookieItem.setCookie;
  module.getCookie = cookieItem.getCookie;
  module.deleteCookie = cookieItem.deleteCookie;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  var module = this;
  var DevBtns = function DevBtns() {
    this.links = document.querySelectorAll("link");
    this.toggled = false;
    this.init();
  };

  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */
  DevBtns.prototype.checkStyles = function () {
    var link, i, media;
    if (!this.toggled) {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("media");
        if (!media) {
          continue;
        }
        link.setAttribute("data-media", media);
        link.setAttribute("media", "none");
      }
      this.toggled = true;
    } else {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("data-media");
        if (!media) {
          continue;
        }
        link.setAttribute("media", media);
        link.removeAttribute("data-media");
      }
      this.toggled = false;
    }
  };
  DevBtns.prototype.setStyles = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-styles");
    if (!btn) {
      return false;
    }
    this.toggled = false;
    btn.addEventListener("click", DEVBTNS.checkStyles.bind(DEVBTNS), false);
  };

  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */
  DevBtns.prototype.checkImages = function () {
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var dAttrSrcsetOri = "data-srcset-ori";
    var attrSrcset = "srcset";
    var i, img;
    var images = document.querySelectorAll("img, source");

    /* находим все изображения, чтобы можно было у них убрать значение атрибута src или srcset */
    /* тем самым мы можем опредлить, из-за каих картинок скачет страница */

    for (i = images.length - 1; i >= 0; i--) {
      img = images[i];
      if (!this.toggled) {
        if (img.hasAttribute(attrSrc)) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        }
        if (img.hasAttribute(attrSrcset)) {
          img.setAttribute(dAttrSrcsetOri, img.getAttribute(attrSrcset));
          img.removeAttribute(attrSrcset);
        }
      } else {
        if (img.hasAttribute(dAttrSrcOri)) {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }
        if (img.hasAttribute(dAttrSrcsetOri)) {
          img.setAttribute(attrSrcset, img.getAttribute(dAttrSrcsetOri));
          img.removeAttribute(dAttrSrcsetOri);
        }
      }
    }
    this.toggled = !this.toggled;
  };
  DevBtns.prototype.setImages = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-images");
    if (!btn) {
      return false;
    }
    btn.addEventListener("click", DEVBTNS.checkImages.bind(DEVBTNS), false);
  };
  DevBtns.prototype.setListeners = function () {
    this.setStyles();
    this.setImages();
  };
  DevBtns.prototype.init = function () {
    if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
      return false;
    }
    this.setListeners();
  };
  new DevBtns();
  module.callback = DevBtns;
});
"use strict";

/**
 * Подгон регуляторной надписи под долю площади окна.
 *
 * По ФЗ «О рекламе» предупреждение обязано занимать не меньше заданной доли
 * площади экрана. Прежняя реализация наращивала кегль циклом «+2px, пока
 * мало» и ничего не знала о ширине контейнера — из-за этого на 1440 строка
 * не влезала (1368px против 1364px) и переносилась на вторую, а кегль в CSS
 * приходилось подбирать руками (148px вместо макетных 150, отдельное
 * значение на 1920 и т. д.).
 *
 * Здесь размер считается формулой, а не перебором, и отдельно решается
 * задача «строка обязана остаться одной»: если натуральная ширина больше
 * доступной, текст сжимается по горизонтали (scaleX) и компенсируется по
 * вертикали (scaleY), чтобы площадь не потерялась.
 *
 * Три интерпретации «площади надписи» — регулятор её не уточняет:
 *   glyph — реально закрашенные пиксели букв (canvas getImageData);
 *   bbox  — сумма прямоугольных рамок букв (в 2–3 раза больше glyph);
 *   block — площадь всей плашки (проще всего защитить перед регулятором).
 *
 * Кегль из макета — НИЖНЯЯ граница, а не цель: закон требует «не меньше»,
 * поэтому если макетный кегль уже даёт нужную долю, он и остаётся.
 *
 * Совместимость: Safari 12+ (см. .browserslistrc). Canvas-замер идёт по
 * кэшу — на ресайзе без смены текста и шрифта getImageData не вызывается.
 */
itsoftApp.createModule('disclaimerFit', function () {
  var module = this;

  // Опорный кегль замера: считаем один раз при 100px и масштабируем.
  var REF_SIZE = 100;
  var LH_FALLBACK = 1.25;
  var ASCENT_FALLBACK = 0.8;
  var DESCENT_FALLBACK = 0.3;
  var BLOCK_MAX_ITER = 4;
  var BLOCK_TOLERANCE = 0.01;
  var AREA_MAX_ITER = 5;
  var AREA_TOLERANCE = 0.01;
  // Запас при обрезке бокса по чернилам, px (см. trimToInk).
  var INK_SAFETY = 1;
  // Ниже этой ширины контейнер считаем неизмеримым (скрыт / нет раскладки).
  var MIN_AVAIL_WIDTH = 8;
  var sharedCanvas = null;
  var sharedCtx = null;
  // WeakMap: элемент → { text, fontKey, mode, widthAtRef, areaAtRef }.
  var measureCache = new WeakMap();
  var getCtx = function getCtx() {
    if (sharedCtx === null && sharedCanvas) {
      return null; // уже пробовали, контекста нет
    }
    if (!sharedCanvas) {
      sharedCanvas = document.createElement('canvas');
      try {
        sharedCtx = sharedCanvas.getContext('2d', {
          willReadFrequently: true
        });
      } catch (err) {
        try {
          sharedCtx = sharedCanvas.getContext('2d');
        } catch (err2) {
          sharedCtx = null;
        }
      }
    }
    return sharedCtx;
  };

  /**
   * Ширина строки без canvas — временным span'ом в потоке документа.
   *
   * Нужна как страховка: 2d-контекста может не быть (canvas отключён
   * политикой приватности, урезанный WebView, серверный рендер в тестах).
   * Раньше модуль в этом случае падал на `ctx.font = …` («Cannot set
   * property 'font' of null»), и надпись оставалась с CSS-кеглем без
   * подгона — то есть регуляторное требование молча не выполнялось.
   */
  var measureWidthDom = function measureWidthDom(text, style, sizePx) {
    var probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:pre;' + 'visibility:hidden;pointer-events:none';
    probe.style.fontFamily = style.fontFamily || 'sans-serif';
    probe.style.fontWeight = style.fontWeight || '400';
    probe.style.fontStyle = style.fontStyle || 'normal';
    probe.style.letterSpacing = style.letterSpacing || 'normal';
    probe.style.textTransform = style.textTransform || 'none';
    probe.style.fontSize = sizePx + 'px';
    probe.textContent = text;
    document.body.appendChild(probe);
    var width = probe.getBoundingClientRect().width;
    document.body.removeChild(probe);
    return width;
  };
  var fontStringFrom = function fontStringFrom(style, sizePx) {
    var weight = style.fontWeight || '400';
    var fStyle = style.fontStyle || 'normal';
    var family = style.fontFamily || 'sans-serif';
    return fStyle + ' ' + weight + ' ' + sizePx + 'px ' + family;
  };
  var resolveLineHeight = function resolveLineHeight(style) {
    var lh = parseFloat(style.lineHeight);
    var fs = parseFloat(style.fontSize);
    if (isFinite(lh) && isFinite(fs) && fs > 0) {
      return lh / fs;
    }
    return LH_FALLBACK;
  };

  /**
   * Площадь надписи при опорном кегле: 'bbox' — рамки букв,
   * 'glyph' — закрашенные пиксели.
   */
  var measureArea = function measureArea(text, fontString, mode) {
    var ctx = getCtx();
    ctx.font = fontString;
    var metrics = ctx.measureText(text);
    var ascent = metrics.actualBoundingBoxAscent || REF_SIZE * ASCENT_FALLBACK;
    var descent = metrics.actualBoundingBoxDescent || REF_SIZE * DESCENT_FALLBACK;
    var width = metrics.width;
    if (mode === 'bbox') {
      return {
        area: width * (ascent + descent),
        width: width
      };
    }
    var w = Math.max(1, Math.ceil(width) + 4);
    var h = Math.max(1, Math.ceil(ascent + descent) + 4);
    var canvas = ctx.canvas;
    canvas.width = w;
    canvas.height = h;
    // После смены размеров контекст сбрасывается — задаём заново.
    ctx.font = fontString;
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#000';
    ctx.fillText(text, 2, ascent + 2);
    var data = ctx.getImageData(0, 0, w, h).data;
    var filled = 0;
    for (var i = 3; i < data.length; i += 4) {
      if (data[i] > 8) {
        filled += 1;
      }
    }
    return {
      area: filled,
      width: width
    };
  };

  /**
   * Обрезать бокс надписи по фактическим ЧЕРНИЛАМ.
   *
   * Строчный бокс шрифта всегда выше самих букв: под базовой линией
   * зарезервировано место под выносные элементы (у, р, д), а капс их
   * почти не использует. У Attentica при кегле 150px отведено 38px, а
   * реальных чернил под базовой линией — 12px. В итоге пустота снизу
   * получалась вдвое больше, чем сверху (39.6px против 20.3px), и плашка
   * занимала 20% высоты экрана вместо необходимого.
   *
   * Отрицательные margin'ы подтягивают кромки бокса к чернилам, и видимый
   * отступ становится равен padding'у контейнера — тому, что задан в CSS,
   * а не сумме padding + случайные метрики шрифта.
   *
   * Идемпотентно: положение чернил внутри бокса от margin'ов не зависит,
   * поэтому повторный вызов на ресайзе даёт тот же результат.
   */
  var trimToInk = function trimToInk(textEl, innerEl, lines, style, size, sy) {
    var ctx = getCtx();
    if (!ctx) {
      return;
    }
    var fontStr = fontStringFrom(style, size);
    ctx.font = fontStr;
    var inkAsc = ctx.measureText(lines[0]).actualBoundingBoxAscent;
    ctx.font = fontStr;
    var inkDesc = ctx.measureText(lines[lines.length - 1]).actualBoundingBoxDescent;
    if (!isFinite(inkAsc) || !isFinite(inkDesc)) {
      return; // старый движок без ink-метрик
    }

    // Базовую линию ищем инлайн-блоком нулевой высоты: он садится на неё
    // нижней кромкой. Замер идёт ПОСЛЕ трансформа, поэтому scaleY уже
    // учтён в координатах, а расстояние до чернил масштабируем сами.
    var probe = document.createElement('span');
    probe.style.cssText = 'display:inline-block;width:0;height:0;overflow:hidden';
    innerEl.insertBefore(probe, innerEl.firstChild);
    var firstBaseline = probe.getBoundingClientRect().bottom;
    innerEl.appendChild(probe);
    var lastBaseline = probe.getBoundingClientRect().bottom;
    innerEl.removeChild(probe);
    var rect = textEl.getBoundingClientRect();
    // Пиксель запаса: подтягиваем ВПЛОТНУЮ к чернилам — и субпиксельное
    // округление вместе с `overflow: hidden` у плашки срезает ножки «Д».
    var topGap = firstBaseline - inkAsc * sy - rect.top - INK_SAFETY;
    var bottomGap = rect.bottom - (lastBaseline + inkDesc * sy) - INK_SAFETY;
    textEl.style.marginTop = (-Math.max(0, topGap)).toFixed(2) + 'px';
    textEl.style.marginBottom = (-Math.max(0, bottomGap)).toFixed(2) + 'px';
  };

  /**
   * Строки надписи. Перенос в макете авторский (<br>), поэтому ширину
   * считаем по САМОЙ ДЛИННОЙ строке, а площадь — суммой по всем: иначе
   * на 414px «лекарственным средством» не помещалось и браузер ломал
   * текст на три строки вместо макетных двух.
   */
  var splitLines = function splitLines(innerEl) {
    var lines = [];
    var current = '';

    // Идём по узлам, а не по innerHTML: перенос считается только если
    // <br> реально виден. В макете он есть на мобилке и скрыт на
    // десктопе (below-desktop-display) — по разметке строка одна там и
    // две тут, и подгон обязан считать по фактическому состоянию.
    var _walk = function walk(node) {
      for (var i = 0; i < node.childNodes.length; i += 1) {
        var child = node.childNodes[i];
        if (child.nodeType === 1 && child.tagName === 'BR') {
          if (window.getComputedStyle(child).display !== 'none') {
            lines.push(current);
            current = '';
          }
          continue;
        }
        if (child.nodeType === 1) {
          if (window.getComputedStyle(child).display === 'none') {
            continue;
          }
          _walk(child);
          continue;
        }
        if (child.nodeType === 3) {
          current += child.nodeValue;
        }
      }
    };
    _walk(innerEl);
    lines.push(current);

    // Canvas рисует текст как есть, а страница — с text-transform. Капс
    // из CSS при строчных буквах в разметке канвас мерил строчными: строка
    // на 15–20% уже нарисованной, площадь рамок меньше фактической
    // (cartilox, 19.10.2026: «БАД. Не является…» строчными в разметке).
    var transform = window.getComputedStyle(innerEl).textTransform;
    var clean = [];
    for (var i = 0; i < lines.length; i += 1) {
      var line = lines[i].replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
      if (transform === 'uppercase') {
        line = line.toUpperCase();
      } else if (transform === 'lowercase') {
        line = line.toLowerCase();
      }
      if (line) {
        clean.push(line);
      }
    }
    return clean.length ? clean : [''];
  };
  var getIntrinsics = function getIntrinsics(el, lines, style, mode) {
    // Ключ кэша — строки ЧЕРЕЗ ПЕРЕНОС, а не через пробел. Разбивка на
    // строки зависит от ширины окна (авторский <br> виден только ниже
    // десктопа), а склеенный через пробел текст одинаков в обоих
    // случаях: после ресайза через брейкпойнт кэш отдавал замеры с
    // прежним числом строк, и подгон уходил в предел сжатия — на 1000
    // после 1440 scaleX 0.7 и одна строка вместо 0.92 и двух, на 375 —
    // одна строка вместо макетных двух (заказчик Elovera, 24.09.2026:
    // «при ресайзе размер дисклеймера должен обновляться»).
    var text = lines.join('\n');
    var fontKey = (style.fontWeight || '') + '|' + (style.fontStyle || '') + '|' + (style.fontFamily || '');
    var cached = measureCache.get(el);
    if (cached && cached.text === text && cached.fontKey === fontKey && cached.mode === mode) {
      return cached;
    }
    var fontStr = fontStringFrom(style, REF_SIZE);
    var ctx = getCtx();
    // Нет 2d-контекста — считаем плашку (block): она меряется геометрией
    // DOM и canvas не требует. Это ХУДШАЯ трактовка площади из трёх, но
    // рабочая; в DEBUG об этом сообщаем.
    var effectiveMode = ctx ? mode : 'block';
    if (!ctx && mode !== 'block') {
      DEBUG && console.warn('disclaimerFit: canvas недоступен, режим «' + mode + '» невозможен — считаем площадь плашки (block)');
    }
    if (ctx) {
      ctx.font = fontStr;
    }
    var widthAtRef = 0;
    var areaAtRef = 0;
    for (var i = 0; i < lines.length; i += 1) {
      if (ctx) {
        ctx.font = fontStr;
        widthAtRef = Math.max(widthAtRef, ctx.measureText(lines[i]).width);
      } else {
        widthAtRef = Math.max(widthAtRef, measureWidthDom(lines[i], style, REF_SIZE));
      }
      if (effectiveMode !== 'block') {
        var measured = measureArea(lines[i], fontStr, effectiveMode);
        areaAtRef += measured.area;
      }
    }
    if (effectiveMode !== 'block' && !areaAtRef) {
      return null;
    }
    var entry = {
      text: text,
      fontKey: fontKey,
      mode: effectiveMode,
      lineCount: lines.length,
      widthAtRef: widthAtRef,
      areaAtRef: effectiveMode === 'block' ? null : areaAtRef,
      // Замеры площади по фактическому кеглю: ключ — сам кегль.
      // Ширина шкалируется линейно и точно, площадь — нет (см. ниже).
      areaBySize: {}
    };
    measureCache.set(el, entry);
    return entry;
  };

  /**
   * Площадь букв при КОНКРЕТНОМ кегле.
   *
   * Экстраполяция с опорных 100px завышает площадь: доля пикселей,
   * закрашенных антиалиасингом по контуру, на мелком кегле больше, чем на
   * крупном. На надписи «не является лекарственным средством» это давало
   * 11% ошибки — расчёт считал, что 155px уже дают 5% площади, а по факту
   * выходило 4.4%, то есть НИЖЕ законного минимума. Поэтому итог
   * проверяем замером на том размере, который реально выставим.
   */
  var areaAtSize = function areaAtSize(entry, lines, style, mode, size) {
    // Ключ — ровно тот кегль, который уйдёт в CSS (там тоже toFixed(2)).
    // Округление крупнее давало замер «соседнего» размера и разброс
    // итоговой доли на ±0.1 п.п. вокруг порога.
    var key = size.toFixed(2);
    if (entry.areaBySize[key] !== undefined) {
      return entry.areaBySize[key];
    }
    var fontStr = fontStringFrom(style, size);
    var sum = 0;
    for (var i = 0; i < lines.length; i += 1) {
      sum += measureArea(lines[i], fontStr, mode).area;
    }
    entry.areaBySize[key] = sum;
    return sum;
  };

  /**
   * Уложить строку в доступную ширину: сжать по горизонтали и
   * компенсировать по вертикали. Возвращает итоговые кегль и масштабы.
   */
  var applyWidth = function applyWidth(entry, size, ctx) {
    var sx = 1;
    var sy = 1;
    var s = size;
    if (!ctx.singleLine) {
      return {
        size: s,
        sx: sx,
        sy: sy,
        clamped: false
      };
    }
    var w1 = entry.widthAtRef / REF_SIZE;
    var natural = w1 * s;
    if (natural <= ctx.availW) {
      return {
        size: s,
        sx: sx,
        sy: sy,
        clamped: false
      };
    }
    var needed = ctx.availW / natural;
    if (needed >= ctx.sxMin) {
      sx = needed;
      // Сжатие по горизонтали компенсируем вертикалью, иначе площадь
      // надписи падает вместе с шириной.
      sy = Math.min(ctx.syMax, 1 / sx);
      return {
        size: s,
        sx: sx,
        sy: sy,
        clamped: false
      };
    }

    // Упёрлись в предел сжатия: кегль задаётся шириной, добрать площадь
    // можно только растяжением по вертикали.
    sx = ctx.sxMin;
    s = ctx.availW / (w1 * ctx.sxMin);
    sy = ctx.syMax;
    return {
      size: s,
      sx: sx,
      sy: sy,
      clamped: true
    };
  };

  /**
   * Подогнать надпись.
   *
   * @param {Element} textEl   элемент с текстом (кегль пишется на него)
   * @param {Element} innerEl  внутренняя обёртка (на неё идёт transform)
   * @param {Object}  options  ratio, mode, sxMin, syMax, singleLine, minSize
   * @returns {Object|null}    { size, scaleX, scaleY, coverage }
   */
  var fit = function fit(textEl, innerEl, options) {
    if (!textEl || !innerEl) {
      return null;
    }
    var opts = options || {};
    var ratio = opts.ratio > 0 ? opts.ratio : 0.05;
    var mode = opts.mode || 'bbox';
    var sxMin = opts.sxMin > 0 ? opts.sxMin : 0.7;
    var syMax = opts.syMax > 0 ? opts.syMax : 1.5;
    var singleLine = !!opts.singleLine;
    var minSize = opts.minSize > 0 ? opts.minSize : 0;

    // Перенос прошлого прогона снимаем: строку сначала пробуем уложить в
    // ОДНУ, и только если не выходит — разрешаем перенос (см. ниже).
    textEl.style.whiteSpace = '';
    var lines = splitLines(innerEl);
    if (!lines[0]) {
      return null;
    }
    var style = window.getComputedStyle(textEl);
    var lhBase = resolveLineHeight(style);
    var availW = textEl.parentElement ? textEl.parentElement.getBoundingClientRect().width : window.innerWidth;

    // Контейнер не измеряется (плашка скрыта на этом брейкпойнте, замер
    // до раскладки, безлэйаутная среда) — НЕ трогаем кегль: при availW→0
    // формула block-режима даёт абсурдный размер (ловили 17052px), а
    // «оставить значение макета» — всегда безопасный исход. Пересчёт
    // придёт со следующим resize или с document.fonts.ready.
    if (!(availW > MIN_AVAIL_WIDTH)) {
      DEBUG && console.warn('disclaimerFit: контейнер надписи не измеряется (' + availW + 'px) — оставляем кегль из CSS');
      return null;
    }
    var viewportArea = window.innerWidth * window.innerHeight;
    var targetArea = viewportArea * ratio;
    var intr = getIntrinsics(textEl, lines, style, mode);
    if (!intr) {
      return null;
    }

    // getIntrinsics мог понизить режим до 'block' (нет canvas).
    var usedMode = intr.mode;
    var wCtx = {
      availW: availW,
      singleLine: singleLine,
      sxMin: sxMin,
      syMax: syMax
    };
    var size;
    var sx = 1;
    var sy = 1;
    var wrapped = false;
    if (usedMode === 'block') {
      size = targetArea / (availW * lhBase * intr.lineCount);
      // Кегль из макета — нижняя граница: закон требует «не меньше».
      if (minSize && size < minSize) {
        size = minSize;
      }
      var placed = applyWidth(intr, size, wCtx);
      size = placed.size;
      sx = placed.sx;
      sy = placed.sy;
    } else {
      // Первое приближение — формулой от опорного замера, дальше
      // уточняем замером на фактическом кегле (см. areaAtSize).
      size = REF_SIZE * Math.sqrt(targetArea / intr.areaAtRef);
      if (minSize && size < minSize) {
        size = minSize;
      }
      var _placed = applyWidth(intr, size, wCtx);
      for (var step = 0; step < AREA_MAX_ITER; step += 1) {
        var effective = areaAtSize(intr, lines, style, usedMode, _placed.size) * _placed.sx * _placed.sy;
        var err = (effective - targetArea) / targetArea;

        // Закон требует «НЕ МЕНЬШЕ» доли, поэтому допуск действует
        // только в плюс: 4.96% при пороге 5% — это нарушение, а не
        // «попали с точностью 1%».
        if (err >= 0 && err <= AREA_TOLERANCE) {
          break;
        }
        // Не добираем, но кегль уже упёрся в ширину и предел
        // растяжения — расти дальше некуда.
        if (err < 0 && _placed.clamped && _placed.sy >= syMax - 1e-6) {
          break;
        }
        // Перебор допустим, если кегль уже на макетном минимуме.
        if (err > 0 && minSize && _placed.size <= minSize + 1e-6) {
          break;
        }

        // Строка сжата, а вертикаль компенсирует не полностью (syMax
        // упёрся, при syMax 1 — не компенсирует вовсе): ширина
        // приколочена к контейнеру, и площадь растёт ЛИНЕЙНО от
        // кегля, а не квадратично. Шаг через корень тогда сходится
        // вдвое медленнее и за AREA_MAX_ITER оставлял недобор ~3%
        // (cartilox, 19.10.2026: надпись во всю ширину, как в макете).
        var linear = _placed.sx < 1 && _placed.sy < 1 / _placed.sx - 1e-6;
        var next = _placed.size * (linear ? targetArea / effective : Math.sqrt(targetArea / effective));
        // Шаг сошёлся, но снизу — подталкиваем вверх, иначе
        // остановимся на доли процента ниже нормы.
        if (err < 0 && next - _placed.size < 0.05) {
          next = _placed.size + 0.5;
        }
        if (minSize && next < minSize) {
          next = minSize;
        }
        if (err > 0 && _placed.size - next < 0.05) {
          break;
        }
        _placed = applyWidth(intr, next, wCtx);
      }
      size = _placed.size;
      sx = _placed.sx;
      sy = _placed.sy;
      // В упёршемся случае вертикаль тянем ровно настолько, насколько
      // не хватает площади, а не всегда до предела.
      if (_placed.clamped) {
        var base = areaAtSize(intr, lines, style, usedMode, size) * sx;
        sy = Math.min(syMax, Math.max(1 / sx, targetArea / base));
      }

      // ── Фолбэк: строка НЕ влезает, а доля площади не набрана ──
      // Упёрлись в предел сжатия (sxMin) и растяжения (syMax), а
      // покрытие всё равно ниже требуемого. Закон требует «не меньше»,
      // поэтому лучше ПЕРЕНЕСТИ текст на следующую строку, чем оставить
      // недобор: с переносом ограничение по ширине снимается, и площадь
      // считается только от кегля (сумма чернил не зависит от того, как
      // строка разбита). Кегль решаем тем же итеративным замером.
      if (singleLine && _placed.clamped) {
        var covered = areaAtSize(intr, lines, style, usedMode, size) * sx * sy;
        if (covered + 1e-6 < targetArea) {
          wrapped = true;
          sx = 1;
          sy = 1;
          size = REF_SIZE * Math.sqrt(targetArea / intr.areaAtRef);
          if (minSize && size < minSize) {
            size = minSize;
          }
          for (var _step = 0; _step < AREA_MAX_ITER; _step += 1) {
            var eff = areaAtSize(intr, lines, style, usedMode, size);
            var _err = (eff - targetArea) / targetArea;
            if (_err >= 0 && _err <= AREA_TOLERANCE) {
              break;
            }
            if (_err > 0 && minSize && size <= minSize + 1e-6) {
              break;
            }
            var _next = size * Math.sqrt(targetArea / eff);
            if (_err < 0 && _next - size < 0.05) {
              _next = size + 0.5;
            }
            if (minSize && _next < minSize) {
              _next = minSize;
            }
            if (_err > 0 && size - _next < 0.05) {
              break;
            }
            size = _next;
          }
          DEBUG && console.warn('disclaimerFit: строка не влезает в одну — ' + 'разрешён перенос, кегль подобран по площади');
        }
      }
    }
    textEl.style.fontSize = size.toFixed(2) + 'px';
    innerEl.style.transform = 'scaleX(' + sx.toFixed(4) + ') scaleY(' + sy.toFixed(4) + ')';

    // Разрешаем перенос ИНЛАЙНОМ: CSS держит nowrap (разбивка строк —
    // авторская, из макета), и снимать его глобально нельзя.
    if (wrapped) {
      textEl.style.whiteSpace = 'normal';
    }

    // Сверка по DOM: ширина строки выше посчитана канвасом, а канвас
    // может мерить не тем шрифтом, что рисует страница (веб-шрифт ещё не
    // дошёл до канваса, другой движок, округления). Тогда строка шире
    // контейнера и уходит за край окна (Elovera, 24.09.2026: «на
    // 1025×779 дисклеймер выходит за правый край»). Мерим фактическую
    // ширину и дожимаем scaleX по факту; площадь добираем вертикалью.
    if (singleLine && !wrapped) {
      var drawnW = innerEl.getBoundingClientRect().width;
      if (drawnW > availW + 0.5) {
        sx *= availW / drawnW;
        sy = Math.min(syMax, Math.max(sy, 1 / sx));
        innerEl.style.transform = 'scaleX(' + sx.toFixed(4) + ') scaleY(' + sy.toFixed(4) + ')';
      }
    }

    // Высота бара обязана учитывать растяжение, иначе высокие буквы
    // обрежутся overflow'ом родителя.
    if (singleLine) {
      textEl.style.height = (size * sy * lhBase * intr.lineCount).toFixed(2) + 'px';
    } else {
      textEl.style.height = '';
    }

    // Подтянуть кромки бокса к буквам: иначе плашка несёт пустой
    // подстрочный запас шрифта и выглядит вдвое ниже снизу.
    if (usedMode !== 'block') {
      trimToInk(textEl, innerEl, lines, style, size, sy);
    }
    var coverage = 0;
    if (usedMode === 'block') {
      var rect = textEl.getBoundingClientRect();
      coverage = viewportArea ? rect.width * rect.height / viewportArea : 0;
    } else {
      // Замер на фактическом кегле, а не пересчёт с опорного, — иначе
      // отчёт покажет норму там, где её нет.
      var area = areaAtSize(intr, lines, style, usedMode, size) * sx * sy;
      coverage = viewportArea ? area / viewportArea : 0;
    }
    return {
      size: size,
      scaleX: sx,
      scaleY: sy,
      coverage: coverage,
      mode: usedMode,
      wrapped: wrapped
    };
  };

  /**
   * Итеративная доводка для режима block: padding и box-sizing родителя
   * сдвигают фактическую площадь относительно расчётной.
   */
  var fitBlock = function fitBlock(textEl, innerEl, options) {
    var result = fit(textEl, innerEl, options);
    if (!result || result.mode !== 'block') {
      return result;
    }
    var target = options.ratio || 0.05;
    for (var i = 0; i < BLOCK_MAX_ITER; i += 1) {
      var err = (result.coverage - target) / target;
      if (Math.abs(err) < BLOCK_TOLERANCE) {
        break;
      }
      var scaled = Object.assign({}, options, {
        minSize: result.size * Math.sqrt(target / result.coverage)
      });
      result = fit(textEl, innerEl, scaled);
      if (!result) {
        break;
      }
    }
    return result;
  };
  var invalidateCache = function invalidateCache() {
    measureCache = new WeakMap();
  };
  module.callback = {
    fit: fit,
    fitBlock: fitBlock,
    invalidateCache: invalidateCache
  };
});
"use strict";

/**
 * Плавающий дисклеймер (разводящая, заказчик 23.10.2026): надпись лежит в
 * шапке подвала, но пока подвал не доскроллен — держится у низа окна
 * (класс is-floating: fixed, белая полупрозрачная плашка). Как только её
 * место в подвале целиком входит в окно — встаёт туда статично, с полями
 * макета (2613:12941). То же поведение, что у дисклеймера боевого сайта.
 *
 * Разметка: <div class="footer-disclaimer js-disclaimer-float"> внутри
 * <footer>. Место в подвале на время плавания держит padding-top подвала
 * (высота надписи) — без него подвал укорачивается и страница дёргается.
 *
 * Подгон кегля — regulatoryDisclaimer.js; ширина контейнера в обоих
 * состояниях одна (100 %), пересчёт не нужен.
 */
itsoftApp.createModule("disclaimerFloat", ["pageLoad", "windowScroll", "windowResize"], function () {
  var module = this;
  var FLOATING_CLASS = "is-floating";
  var DisclaimerFloat = function DisclaimerFloat(el) {
    this.el = el;
    this.footer = el.closest("footer");
    this.floating = null;
    if (!this.footer) {
      return;
    }
    this.init();
  };

  /* Высота надписи в подвале (с полями макета) — её и резервируем; плавающая
     ниже (поля 16), мерить её нельзя: место в подвале прыгало бы при смене */
  DisclaimerFloat.prototype.measure = function () {
    var wasFloating = this.el.classList.contains(FLOATING_CLASS);
    if (wasFloating) {
      this.el.classList.remove(FLOATING_CLASS);
    }
    this.dockHeight = this.el.offsetHeight;
    if (wasFloating) {
      this.el.classList.add(FLOATING_CLASS);
    }
  };
  DisclaimerFloat.prototype.update = function () {
    /* Верх подвала в окне; при плавании место надписи держит padding-top */
    var dockTop = this.footer.getBoundingClientRect().top;
    var floating = dockTop + this.dockHeight > window.innerHeight;
    if (floating === this.floating) {
      return;
    }
    this.floating = floating;
    this.footer.style.paddingTop = floating ? this.dockHeight + "px" : "";
    this.el.classList.toggle(FLOATING_CLASS, floating);
    this.placeAbove();
  };

  /* Элементы, которые стоят над дисклеймером у низа окна (cookie-плашка
     Bitrix `.disc-cookie` — атрибут data-above-disclaimer): bottom = высота
     плавающей надписи, у подвала — 0 */
  DisclaimerFloat.prototype.placeAbove = function () {
    var self = this;
    var items = document.querySelectorAll("[data-above-disclaimer]");
    Array.prototype.forEach.call(items, function (item) {
      item.style.bottom = self.floating ? self.el.offsetHeight + "px" : "0px";
    });
  };
  DisclaimerFloat.prototype.init = function () {
    var self = this;
    this.measure();
    this.update();
    itsoftApp.modules.windowScroll.addEvent(function () {
      self.update();
    });
    itsoftApp.modules.windowResize.addEvent(function () {
      /* Кегль пересчитан (regulatoryDisclaimer) — высота другая */
      self.measure();
      self.floating = null;
      self.update();
    });

    /* Подгон кегля (regulatoryDisclaimer) меняет высоту надписи — мерим заново */
    this.el.addEventListener("disclaimer:fit", function () {
      self.measure();
      self.floating = null;
      self.update();
      self.placeAbove();
    });
  };
  var items = document.querySelectorAll(".js-disclaimer-float");
  if (!items.length) {
    return false;
  }
  Array.prototype.forEach.call(items, function (el) {
    el.disclaimerFloat = new DisclaimerFloat(el);
  });
  module.callback = DisclaimerFloat;
});
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
itsoftApp.createModule("draggable", ['windowScroll'], function () {
  var module = this;
  var Draggable = /*#__PURE__*/function () {
    function Draggable(container, state) {
      _classCallCheck(this, Draggable);
      if (!container) {
        return;
      }
      this.names = {
        dragging: '_dragging'
      };
      this.slider = container;
      this.left = this.slider.querySelector('.js-draggable-left');
      this.right = this.slider.querySelector('.js-draggable-right');
      this.line = this.slider.querySelector('[data-type="resize"]');
      this.offsetTop = 150;
      this.state = _objectSpread(_objectSpread({}, state), {}, {
        width: state.width || this.slider.clientWidth / this.defaultLineOffset
      });
      this.activeFlag = false;
      this.dragging = false;
      this.medias = [window.matchMedia("(max-width: 1023px)"), window.matchMedia("(max-width: 767px)"), window.matchMedia("(max-width: 480px)")];
      this.init();
    }
    return _createClass(Draggable, [{
      key: "init",
      value: function init() {
        this.bindMethods();
        this.addEventListeners();
        this.render(this.state);
        this.onScroll();
      }
    }, {
      key: "bindMethods",
      value: function bindMethods() {
        this.mouseDownHandler = this.mouseDownHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);
        this.mouseUpDocHandler = this.mouseUpDocHandler.bind(this);
        this.moveHandler = this.moveHandler.bind(this);
        this.resizeHandler = this.resizeHandler.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.scrollHandler = this.scrollHandler.bind(this);
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.slider.addEventListener('mousedown', this.mouseDownHandler);
        this.slider.addEventListener('mouseup', this.mouseUpHandler);
        this.slider.addEventListener('touchstart', this.onTouchStart, {
          passive: false
        });
        this.slider.addEventListener('touchmove', this.onTouchMove, {
          passive: false
        });
        this.slider.addEventListener('touchend', this.onTouchEnd, {
          passive: false
        });
        document.addEventListener('mouseup', this.mouseUpDocHandler);
        document.addEventListener('mousemove', this.moveHandler);
        window.addEventListener('resize', this.resizeHandler);
        for (var index = 0; index < this.medias.length; index++) {
          var element = this.medias[index];
          element.addEventListener('change', this.resizeHandler);
        }
        itsoftApp.modules.windowScroll.addEvent(this.scrollHandler);
      }
    }, {
      key: "scrollHandler",
      value: function scrollHandler(e) {
        this.onScroll(e);
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler(e) {
        if (e.type === 'resize' && window.innerWidth > 1023) {
          this.onResize(e);
        } else if (e.type === 'change') {
          this.onResize(e);
        }
      }
    }, {
      key: "onResize",
      value: function onResize(e) {
        this.setDefaultPos();
      }
    }, {
      key: "onScroll",
      value: function onScroll(e) {
        var _this = this;
        if (this.isBlockInWindow(this.slider) && !this.activeFlag) {
          this.activeFlag = true;
          this.slider.classList.add('_active');
          setTimeout(function () {
            _this.slider.classList.remove('_active');
          }, 3000 + 700);
        }
      }
    }, {
      key: "setDefaultPos",
      value: function setDefaultPos() {
        this.state.width = this.slider.clientWidth / this.defaultLineOffset;
        this.render(this.state);
      }
    }, {
      key: "render",
      value: function render(state) {
        this.left.style.clipPath = "inset(0px 0px 0px -".concat(state.width, "px)");
        this.right.style.clipPath = "inset(0px 0px 0px ".concat(state.width, "px)");
        this.line.style.marginLeft = state.width + 'px';
      }
    }, {
      key: "update",
      value: function update(props) {
        this.state = _objectSpread(_objectSpread({}, this.state), props);
        this.render(this.state);
      }
    }, {
      key: "mouseDownHandler",
      value: function mouseDownHandler(e) {
        if (e.target.dataset.type === 'resize') {
          var event = e.touches ? e.touches[0] : e;
          this.dragging = true;
          this.currentClientX = event.clientX;
          this.slider.classList.add(this.names.dragging);
          if (this.activeFlag) {
            this.slider.classList.remove('_active');
            this.activeFlag = false;
          }
        }
      }
    }, {
      key: "mouseUpHandler",
      value: function mouseUpHandler(e) {
        e.stopPropagation();
        this.dragging = false;
        this.slider.classList.remove(this.names.dragging);
      }
    }, {
      key: "mouseUpDocHandler",
      value: function mouseUpDocHandler(e) {
        this.dragging = false;
        this.slider.classList.remove(this.names.dragging);
      }
    }, {
      key: "moveHandler",
      value: function moveHandler(e) {
        if (!this.dragging) {
          return;
        }
        var event = e.touches ? e.touches[0] : e;
        if (e.touches) {
          e.preventDefault();
        }
        var newClientX = this.currentClientX - event.clientX;
        var curValue = this.state.width - newClientX;
        var stopSideOffset = 1;
        if (curValue < -stopSideOffset) {
          this.update({
            width: -stopSideOffset
          });
          return;
        }
        if (curValue > this.slider.clientWidth + stopSideOffset) {
          this.update({
            width: this.slider.clientWidth + stopSideOffset
          });
          return;
        }
        this.update({
          width: curValue
        });
        this.currentClientX = event.clientX;
      }
    }, {
      key: "onTouchStart",
      value: function onTouchStart(e) {
        this.mouseDownHandler(e);
      }
    }, {
      key: "onTouchMove",
      value: function onTouchMove(e) {
        this.moveHandler(e);
      }
    }, {
      key: "onTouchEnd",
      value: function onTouchEnd(e) {
        this.mouseUpHandler(e);
      }
    }, {
      key: "bodyLock",
      value: function bodyLock(flag) {
        if (window.innerWidth < 1024) {
          if (flag) {
            document.documentElement.classList.add('body-lock');
          } else {
            document.documentElement.classList.remove('body-lock');
          }
        }
      }
    }, {
      key: "isBlockInWindow",
      value: function isBlockInWindow(el) {
        var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom;
        var pointTop = top - this.offsetTop;
        var pointBottom = bottom - this.offsetTop;
        return pointTop < window.innerHeight && pointBottom < window.innerHeight;
      }
    }, {
      key: "defaultLineOffset",
      get: function get() {
        return window.innerWidth > 1023 ? 1.35 : 1.065;
      }
    }]);
  }();
  function initDraggable() {
    var selectors = document.querySelectorAll('.js-draggable');
    var _iterator = _createForOfIteratorHelper(selectors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        var instance = new Draggable(el, {});
        if (!el.instance) {
          el.instance = instance;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  initDraggable();
  module.callback = Draggable;
});
"use strict";

itsoftApp.createModule("focusVisible", function () {
  /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */
  /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
  var module = this;
  var FocusVisible = function FocusVisible() {
    this.path = "/assets/scripts/focus-visible/focus-visible.min.js";
    this.init();
  };
  FocusVisible.prototype.init = function () {
    itsoftApp.loadScript(this.path);
  };
  new FocusVisible();
  module.callback = FocusVisible;
});
"use strict";

/**
 * Шапка лежит поверх первого экрана (absolute); после прокрутки ниже своей
 * высоты — прилипает к верху (is-fixed, белый фон), как на боевом сайте.
 * scrollTo.js берёт отступ якорей из её высоты, если она absolute/fixed.
 */
itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll"], function () {
  var module = this;
  var header = document.querySelector(".js-header");
  if (!header) {
    return false;
  }
  var FIXED = "is-fixed";
  var fixed = false;
  var update = function update(scrollY) {
    var next = scrollY > header.offsetHeight;
    if (next !== fixed) {
      fixed = next;
      header.classList.toggle(FIXED, fixed);
    }
  };
  update(window.pageYOffset);
  itsoftApp.modules.windowScroll.addEvent(function () {
    update(window.pageYOffset);
  });
  module.callback = {
    update: update
  };
});
"use strict";

itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll"], function () {
  var module = this;
  window.lazyQueue = [];
  window.lazyInitQueue = function () {
    if (!window.lazyQueue.length) {
      return;
    }
    while (window.lazyQueue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      window.lazyQueue.shift()();
    }
  };
  window.lazyFunctions = {
    slider: function slider(element) {
      var sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
      var sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

      if (sliderSettingsKey && sliderSettingsObject) {
        new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
      } else {
        new itsoftApp.modules.slidersLibrary.callback(element);
      }
    },
    scrollTrigger: function scrollTrigger(element) {
      itsoftApp.modules.scrollActions.callback(element, true, false);
    },
    accordion: function accordion(element) {
      new itsoftApp.modules.accordion.callback(element);
    },
    loadSection: function loadSection(element) {
      itsoftApp.modules.loadItems.initLoad(element);
    },
    videoInView: function videoInView(element) {
      itsoftApp.modules.videoInView.play(element);
    },
    animateTitle: function animateTitle(element) {
      if (element.hasAttribute('data-delay')) {
        setTimeout(function () {
          new itsoftApp.modules.animateTitle.callback(element);
        }, element.dataset.delay);
      } else {
        new itsoftApp.modules.animateTitle.callback(element);
      }
    }
  };
  function executeLazyFunction(element) {
    var lazyFunctionName;
    if (element.classList.contains('js-animate-title')) {
      lazyFunctionName = 'animateTitle';
    } else {
      var lazyFunctionName = element.getAttribute("data-lazy-function");
    }
    var lazyFunction = window.lazyFunctions[lazyFunctionName];
    if (!lazyFunction) return;
    lazyFunction(element);
  }
  var Lazy = function Lazy() {
    this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";
    this.init();
  };

  /* Все наблюдатели — чтобы после подмены контента страницы без
     перезагрузки (chooseProduct.js) подхватить новые элементы: update() */
  var instances = [];
  var observe = function observe(settings) {
    var instance = new LazyLoad(settings); // eslint-disable-line

    instances.push(instance);
    return instance;
  };
  module.refresh = function () {
    instances.forEach(function (instance) {
      instance.update();
    });
  };
  Lazy.prototype.setSettings = function () {
    window.ll = observe({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".lazy, .lazyload",
      // eslint-disable-line
      class_loaded: "loaded",
      // eslint-disable-line,
      class_entered: "entered" // eslint-disable-line,
    });
    window.llCallback = observe({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".lazy-script, .js-script",
      // eslint-disable-line
      class_entered: "js-script-entered",
      // eslint-disable-line,
      callback_enter: executeLazyFunction
    });
    observe({
      // eslint-disable-line
      threshold: -150,
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".js-anim",
      // eslint-disable-line
      class_entered: "js-anim--show" // eslint-disable-line,
    });
    observe({
      // eslint-disable-line
      threshold: -150,
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".js-animate-title",
      // eslint-disable-line
      callback_enter: executeLazyFunction
    });

    // Ролики секций (/cartilox-t/): старт, когда блок уже на экране —
    // у общего .js-script порог по умолчанию +300px, и одноразовый ролик
    // начинал играть ещё за кадром
    observe({
      // eslint-disable-line
      threshold: -150,
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".js-video-in-view",
      // eslint-disable-line
      callback_enter: executeLazyFunction
    });

    // Заголовки первого экрана: с порогом -150 заголовок, который весь
    // лежит выше 150px от верха окна (hero на 320: 56..138), не
    // появляется никогда. Здесь порога нет; второй запуск из общего
    // наблюдателя гасит проверка в animateTitle
    observe({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".js-animate-title-now",
      // eslint-disable-line
      callback_enter: executeLazyFunction
    });
  };
  Lazy.prototype.init = function () {
    itsoftApp.loadScript(this.path, this.setSettings);
  };
  new Lazy();
  module.callback = Lazy;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var module = this;
  var LinksWithHash = function LinksWithHash() {
    this.links = document.querySelectorAll("a[href='#']");
    this.isLocal = itsoftApp.isLocal;
    this.init();
  };

  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */
  LinksWithHash.prototype.linksWithHashHandler = function (e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  };

  // Привязка функций к событиям
  LinksWithHash.prototype.addListener = function () {
    var LINKSWITHHASH = this;
    for (var i = 0, len = LINKSWITHHASH.links.length, link; i < len; i++) {
      link = LINKSWITHHASH.links[i];
      link.addEventListener("click", LINKSWITHHASH.linksWithHashHandler.bind(LINKSWITHHASH), false);
    }
  };

  // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.
  LinksWithHash.prototype.checkRaven = function () {
    if (typeof Raven !== "undefined" && !this.isLocal) {
      var extra = {};

      // Формируем объект, в котором перечислены все найденные ссылки,
      // причём с указанием их html-кода
      // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)
      Array.prototype.forEach.call(this.links, function (link, index) {
        var html = link.outerHTML;
        extra["link" + (index + 1)] = html;
      });
      Raven.captureMessage("[module linksWithHash] links with href='#' found", {
        level: "warning",
        // one of 'info', 'warning', or 'error'
        extra: extra
      });
    }
  };
  LinksWithHash.prototype.init = function () {
    if (!this.links.length) {
      return false;
    }
    DEBUG && console.log("%c[module linksWithHash] " + this.links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
    this.addListener();
    this.checkRaven();
  };
  new LinksWithHash();
  module.callback = LinksWithHash;
});
"use strict";

/**
 * Шапка: мобильное меню и подменю.
 *   .js-header            — шапка; is-opened — панель меню раскрыта
 *   .js-header-toggle     — бургер (aria-expanded)
 *   .js-header-sub        — пункт с подменю; .js-header-sub-toggle раскрывает
 *                           его (is-opened на пункте) — на мобилке аккордеоном,
 *                           на десктопе по клику (ховер — CSS); клик вне и Esc
 *                           закрывают.
 * При открытом меню прокрутка страницы заперта (overflow на html).
 */
itsoftApp.createModule("mobMenu", ["windowResize"], function () {
  var module = this;
  var header = document.querySelector(".js-header");
  if (!header) {
    return false;
  }
  var OPENED = "is-opened";
  var toggle = header.querySelector(".js-header-toggle");
  var subs = header.querySelectorAll(".js-header-sub");
  // Ниже десктопа подменю раскрывается аккордеоном: высота анимируется от
  // текущей к целевой (CSS держит height: 0 + overflow: hidden), по окончании
  // — auto. На десктопе панель выпадающая, высоту не трогаем
  var mobile = window.matchMedia("(max-width: 1023px)");

  // Слайдер баннеров в меню (два и больше баннеров — .js-menu-banner-slider):
  // Swiper грузится лениво при первом открытии меню, не на загрузке страницы
  // (заказчик, 23.10.2026). Без слайдера в разметке ничего не грузится
  var bannerSlider = null;
  var initBannerSlider = function initBannerSlider() {
    var el = header.querySelector(".js-menu-banner-slider");
    var library = itsoftApp.modules.slidersLibrary;
    var settings = itsoftApp.modules.slidersSettings;
    if (!el || bannerSlider || !library || !library.callback || !settings || !settings.getSettings) {
      return;
    }
    bannerSlider = new library.callback(el, settings.getSettings(el.getAttribute("data-slider-settings")));
  };
  var setMenu = function setMenu(opened) {
    header.classList.toggle(OPENED, opened);
    toggle.setAttribute("aria-expanded", opened ? "true" : "false");
    document.documentElement.style.overflow = opened ? "hidden" : "";
    if (opened) {
      initBannerSlider();
    }
  };
  var slide = function slide(panel, opened) {
    var from = panel.getBoundingClientRect().height;
    panel.style.transition = "none";
    panel.style.height = from + "px";
    panel.offsetHeight; // eslint-disable-line no-unused-expressions
    panel.style.transition = "";
    panel.style.height = (opened ? panel.scrollHeight : 0) + "px";
    var _done = function done(evt) {
      if (evt.target !== panel) {
        return;
      }
      panel.removeEventListener("transitionend", _done);
      if (panel.closest(".js-header-sub").classList.contains(OPENED)) {
        panel.style.height = "auto";
      }
    };
    panel.addEventListener("transitionend", _done);
  };
  var setSub = function setSub(sub, opened) {
    var panel = sub.querySelector(".js-header-sub-panel");
    if (sub.classList.contains(OPENED) === opened) {
      return;
    }
    sub.classList.toggle(OPENED, opened);
    sub.querySelector(".js-header-sub-toggle").setAttribute("aria-expanded", opened ? "true" : "false");
    if (panel && mobile.matches) {
      slide(panel, opened);
    }
  };
  var closeSubs = function closeSubs(except) {
    Array.prototype.forEach.call(subs, function (sub) {
      if (sub !== except) {
        setSub(sub, false);
      }
    });
  };
  toggle.addEventListener("click", function () {
    setMenu(!header.classList.contains(OPENED));
  });
  Array.prototype.forEach.call(subs, function (sub) {
    var button = sub.querySelector(".js-header-sub-toggle");
    button.addEventListener("click", function () {
      var opened = !sub.classList.contains(OPENED);
      closeSubs(sub);
      setSub(sub, opened);
    });
  });
  document.addEventListener("click", function (evt) {
    if (!evt.target.closest(".js-header-sub")) {
      closeSubs();
    }
  });
  document.addEventListener("keyup", function (evt) {
    if (evt.key === "Escape") {
      closeSubs();
      setMenu(false);
    }
  });

  /* Повернули планшет в ландшафт — панели нет, замок прокрутки снять;
     инлайновые высоты подменю десктопному выпадающему списку не нужны */
  itsoftApp.modules.windowResize.addEvent(function () {
    if (window.innerWidth > 1023) {
      if (header.classList.contains(OPENED)) {
        setMenu(false);
      }
      Array.prototype.forEach.call(header.querySelectorAll(".js-header-sub-panel"), function (panel) {
        panel.style.height = "";
      });
    }
  });
  module.callback = {
    open: function open() {
      setMenu(true);
    },
    close: function close() {
      setMenu(false);
    }
  };
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;

  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */
  var _singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;
    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }
    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");
    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift();

      // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.
      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }
    singleFunctionFired = true;
    if (!flag) {
      $window.removeEventListener("load", _singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");
      if (body.hasAttribute("data-no-script")) {
        body.removeAttribute("data-no-script");
      }
    }
  };

  // Привязка собитий и функции-обработчика
  if (document.readyState === "complete") {
    _singleLoadFunction();
  } else {
    $window.addEventListener("load", _singleLoadFunction);
  }

  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    // Если страница ещё не загружена полность, то добавляем в очередь
    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length);

      // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
"use strict";

/**
 * Лёгкий параллакс для элементов с data-parallax="<скорость>".
 *
 * Элемент сдвигается по вертикали относительно центра вьюпорта:
 * смещение = (центр вьюпорта − центр элемента) * скорость.
 * Скорость 0.05–0.1 — заметно, но не «уплывает» за пределы блока.
 *
 * Ниже планшета отключён: там карточки идут обычным списком,
 * и сдвиг только мешает.
 */
itsoftApp.createModule("parallax", ["windowScroll", "windowResize"], function () {
  var module = this;
  var Parallax = function Parallax() {
    this.items = document.querySelectorAll("[data-parallax]");
    if (!this.items.length) {
      return;
    }
    this.enabled = false;
    this.frame = null;
    this.init();
  };
  Parallax.prototype.checkEnabled = function () {
    /* Тот же брейкпойнт, что и у макета: параллакс только на десктопе */
    this.enabled = window.innerWidth > 1023;
    if (!this.enabled) {
      this.reset();
    }
  };
  Parallax.prototype.reset = function () {
    Array.prototype.forEach.call(this.items, function (item) {
      item.style.transform = "";
    });
  };
  Parallax.prototype.update = function () {
    if (!this.enabled) {
      return;
    }
    var viewportCenter = window.innerHeight / 2;
    Array.prototype.forEach.call(this.items, function (item) {
      var rect = item.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        return;
      }
      var speed = parseFloat(item.getAttribute("data-parallax")) || 0;
      var shift = (viewportCenter - (rect.top + rect.height / 2)) * speed;
      item.style.transform = "translate3d(0, " + shift.toFixed(2) + "px, 0)";
    });
  };

  /*
   * Прошлый кадр отменяем, а не держим флаг «уже запрошено»: если первый
   * requestAnimationFrame не отрисовался (фоновая вкладка, headless без
   * композитора), флаг залипал и параллакс молчал навсегда.
   * Исправление из cartilox-medznat.
   */
  Parallax.prototype.request = function () {
    var self = this;
    if (this.frame !== null) {
      window.cancelAnimationFrame(this.frame);
    }
    this.frame = window.requestAnimationFrame(function () {
      self.frame = null;
      self.update();
    });
  };
  Parallax.prototype.init = function () {
    var self = this;
    this.checkEnabled();
    this.request();
    itsoftApp.modules.windowScroll.addEvent(function () {
      self.request();
    });
    itsoftApp.modules.windowResize.addEvent(function () {
      self.checkEnabled();
      self.request();
    });
  };
  new Parallax();
  module.callback = Parallax;
});
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function () {
  var module = this;
  module.$wrapper = document.querySelector(".l-wrapper");
  var popups = document.querySelectorAll("." + "popup"); // this.popupClass

  if (!popups.length) {
    // TODO: Убрать или переделать, чтобы тесты прошли
    return false;
  }

  // Локальные переменные
  var $body = document.body;
  var $document = document.documentElement;
  // const activePopups = document.querySelectorAll("[data-bg-opened='true']");
  // const popupBox = document.querySelector("#popup-box");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var staticBackUrl = window.location.pathname;
  var dAttrAutohide = "data-autohide";
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  // const disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  // const save = document.querySelector(".js-save");
  // const slider = {};
  // const hashedPopups = document.querySelectorAll("data-hash");
  window.currentOpenedPopup = undefined;
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;
  var currentSlide;
  var activeButton;
  // let pageHash;

  // if (hashedPopups.length > 0) {
  //     pageHash = location.hash;
  // }

  var Breakpoint = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };
  var Popup = function Popup(popup) {
    if (!popup) {
      try {
        throw new Error("Не передан обязательный аргумент popup");
      } catch (err) {
        console.log(err);
      }
    }
    this.state = {
      closeButtonsAvailability: false,
      openButtonsAvailability: false,
      initedExemplar: false,
      opened: false
    };
    this.popup = popup;
    this.popupID = popup.id;
    this.openPopupBtnSelector = ".js-open-popup[data-popup-id='" + popup.id + "']";
    this.closePopupBtnSelector = ".js-close-popup[data-popup-id='" + popup.id + "']";
    this.openPopupBtns = document.querySelectorAll(this.openPopupBtnSelector);
    this.closePopupBtns = document.querySelectorAll(this.closePopupBtnSelector);
    this.popupClass = "popup";
    this.openedClass = "is-opened";
    this.dAttrSelector = "data-popup-selector";
    this.dAttrBgClose = "data-bg-close";
    this.hiddenClass = "g-hidden";
    this.evNameOpen = "popups:open";
    this.evNameClose = "popups:close";
    this.wrapperAbsClass = "is-abs";
    this.wrapperOverflow = "is-over";
    this.popupOpenedClass = "is-popup-opened";
    this.dAttrUrl = "data-url";
    this.dAttrHide = "data-hide";
    this.dAttrClose = "data-close-popup";
    this.hideDelayDefault = 3500;
    this.init();
  };
  Popup.prototype.globalState = {
    listenersAdded: false,
    historyPushed: false
  };
  Popup.prototype.openedPopups = [];
  Popup.prototype.autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  Popup.prototype.lastOpenedPopup = null;
  Popup.prototype.detachEvents = function () {
    this.popup.removeEventListener(this.evNameOpen, this.popupOpen);
    this.popup.removeEventListener(this.evNameClose, this.popupClose);
    this.popup.removeEventListener("click", this.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.removeEventListener("click", this.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.removeEventListener("click", this.closePopupBtnClick);
    });
  };
  Popup.prototype.init = function () {
    var POPUP = this;

    /**
     * Обработчик нажатий на кнопки клавиатуры.
     * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
     *
     * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
     * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
     *
     * @param  {object} e Event
     */
    Popup.prototype.keyController = function (evt) {
      // Обрабатываем только нажатие на ESC,
      // а все остальные нажатия игнорируем.
      if (evt.keyCode !== 27) {
        return;
      }
      if (!POPUP.openedPopups.length) {
        return;
      }
      var maxZI = 0;
      Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
        var popup = el;
        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);
        if (isNaN(zi)) {
          zi = 0;
        }
        if (zi >= maxZI) {
          maxZI = zi;
          POPUP.lastOpenedPopup = popup;
        }
      });
      if (!POPUP.lastOpenedPopup) {
        return;
      }

      // Закрываем только последнюю открытую всплывашку
      if (!POPUP.lastOpenedPopup.hasAttribute("data-save")) {
        POPUP.lastOpenedPopup.dispatchEvent(window.closeEvent);
      }
    };
    if (!this.globalState.listenersAdded) {
      if (window.CustomEvent && typeof window.CustomEvent === "function") {
        window.closeEvent = new CustomEvent(this.evNameClose, {
          detail: {
            name: "Закрытие"
          }
        });
        window.openEvent = new CustomEvent(this.evNameOpen, {
          detail: {
            name: "Открытие"
          }
        });
      } else {
        window.closeEvent = document.createEvent("CustomEvent");
        window.openEvent = document.createEvent("CustomEvent");
        window.closeEvent.initCustomEvent(this.evNameClose, true, true, {
          name: "Закрытие"
        });
        window.openEvent.initCustomEvent(this.evNameOpen, true, true, {
          name: "Открытие"
        });
      }
      window.addEventListener("beforeunload", this.windowUnload);
      window.addEventListener("keyup", this.keyController);
      this.globalState.listenersAdded = true;
    }
    if (this.closePopupBtns.length > 0) {
      this.state.closeButtonsAvailability = true;
    }
    if (this.openPopupBtns.length > 0) {
      this.state.openButtonsAvailability = true;
    }

    /**
     * Клик по кнопкам, открывающим всплывахи.
     * Какую именно всплывашку открыть - обозначено в data- атрибуте.
     */
    Popup.prototype.openPopupBtnClick = function (evt) {
      evt.preventDefault();
      var self = this;
      var dataSlide = self.getAttribute("data-slide");
      // const selector = self.getAttribute(POPUP.dAttrSelector);

      dataSlide ? currentSlide = dataSlide : currentSlide = undefined;

      // if (selector) {
      // if (popup) {
      POPUP.popup.dispatchEvent(window.openEvent);
      // }
      // }

      // else {
      //     const popupType = self.getAttribute("data-popup-type")

      //     if (popupType = "image") {
      //         createImagePopup(self);
      //     } else {
      //         return;
      //     }
      // }
    };

    /**
     * Клик по кнопкам, закрывающим всплывашку.
     * Будет закрыта "родительская" всплывашка
     * (поиск по ближайшему родителю с нужным классом).
     */
    Popup.prototype.closePopupBtnClick = function () {
      var self = this;
      var checkbox = null;
      // const popup = self.closest("." + popupClass);
      var _onBoxCheck = function onBoxCheck(evt) {
        if (evt.currentTarget.classList.contains("js-error")) {
          checkbox.classList.remove("js-error");
          checkbox.removeEventListener("change", _onBoxCheck);
        }
      };
      if (this.classList.contains("js-save")) {
        if (self.hasAttribute("data-checkbox")) {
          var checkboxID = self.getAttribute("data-checkbox");
          checkbox = confirmation.querySelector(checkboxID);
          if (!checkbox.checked) {
            checkbox.classList.add("js-error");
            checkbox.addEventListener("change", _onBoxCheck);
            return;
          }
        }
        itsoftApp.modules.cookie.setCookie(this);
      }
      POPUP.popup.dispatchEvent(window.closeEvent);
    };

    /**
     * Все действия, связанные с открытием всплывашки
     */
    Popup.prototype.popupOpen = function () {
      var self = this;
      if (self.classList.contains(POPUP.openedClass)) {
        return;
      }

      // Если до этого уже были открыты всплывашки,
      // то вычисляем наибольший z-index, и присваиваем его
      // новой открывающейся всплывашке.
      // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
      // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.

      if (POPUP.openedPopups.length > 0) {
        var maxZI = 0;
        Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
          var popup = el;
          if (popup.getAttribute("data-ignore") === "true") {
            return;
          }
          var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);
          if (isNaN(zi)) {
            zi = 0;
          }
          maxZI = Math.max(maxZI, zi);
        });
        if (maxZI > 0) {
          self.style.zIndex = maxZI + 1;
          DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
        }
      }

      // Вычисляем текущую величину прокрутки страницы
      // (делаем это до того, как будут произведены какие-либо дальнейшие действия).
      var scrTop = getScrTop();
      DEBUG && console.log("[module popups] scrTop: " + scrTop);

      // Если есть fixed элементы на странице,
      // то задаём им padding-right, равный ширине полосы прокрутки.
      // Без этого такие элементы будут дёргаться,
      // так как в процессе открытия всплывашки слегка меняются общие стили страницы.
      if (hasFixedElems) {
        var scrollbarWidth = getScrollbarWidth();
        DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = scrollbarWidth + "px";
        });
      }

      // NOTE: Это из-за плашки browser-update,
      // которая задаёт <html> ненулевой margin-top,
      // (в случае, если плашка об устаревшем браузере показана)
      // из-за которого страница "прыгает".
      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;
      if (mtExists) {
        scrTop -= mt;
      }

      // Основная магия происходит здесь.
      // Элементу .l-wrapper задаётся класс, который одновременно
      // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
      // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
      // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
      // которое было до этого у <body> (мы посчитали эту величину ранее).
      // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.
      if (module.$wrapper) {
        module.$wrapper.classList.add(POPUP.wrapperAbsClass);
        module.$wrapper.scrollTop = scrTop;
      }

      // NOTE: Это из-за плашки browser-update
      if (mtExists) {
        $document.scrollTop = 0;
      }

      // Это для отсутсвия скролла у <body> в некоторых редких случаях
      // (например, если висит плашка об устаревшем браузере)
      if (!POPUP.popup.hasAttribute("data-scroll")) {
        $body.classList.add(POPUP.popupOpenedClass);
      }

      // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
      // при открытии других всплывашек.
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).
      var autohidePopupsOpened = [].filter.call(POPUP.autohidePopups, function (el) {
        return el.classList.contains(POPUP.openedClass);
      });
      if (autohidePopupsOpened.length > 0) {
        DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
        Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
          el.classList.remove(POPUP.openedClass);
        });
      }
      if (window.currentOpenedPopup) {
        window.currentOpenedPopup = undefined;
      }

      // Далее, делаем нашу всплывашку видимой (за счёт класса)
      self.classList.add(POPUP.openedClass);
      window.currentOpenedPopup = self;
      POPUP.openedPopups.push(self);
      POPUP.state.opened = true;
      var videoItem = self.querySelector(".js-video-item");
      if (videoItem) {
        itsoftApp.modules.video.videoPlay(videoItem);
      }
      var isIncludeSlider = self.hasAttribute("data-slider");
      if (isIncludeSlider) {
        if (self.getAttribute("data-slider") !== "true") {
          var sliderContainer = self.closest(".js-slider");
          self.setAttribute("data-slider", "true");
          itsoftApp.modules.slidersLibrary.callback(sliderContainer, undefined, undefined, self.getAttribute("data-slider-name"), currentSlide);
        } else {
          itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
        }
      }
      if (self.hasAttribute("data-destroy-device")) {
        var _onWindowResize = function onWindowResize() {
          if (itsoftApp.utils.getViewportSize() >= Breakpoint[self.getAttribute("data-destroy-device")]) {
            self.dispatchEvent(window.closeEvent);
            window.removeEventListener("resize", _onWindowResize);
          }
        };
        window.addEventListener("resize", _onWindowResize);
      }

      // Здесь предусмотрена возможность
      // закрыть текущую всплывашку через определённый промежуток времени
      // (например, всплывашка с коротким информационным сообщением).
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).
      var hideDelay = self.getAttribute(POPUP.dAttrHide);
      if (hideDelay) {
        hideDelay = parseInt(hideDelay, 10);
        hideDelay = isNaN(hideDelay) ? POPUP.hideDelayDefault : hideDelay;
        setTimeout(function () {
          self.dispatchEvent(window.closeEvent);
        }, hideDelay);
      }

      // При необходимости, можно управлять адресной строкой браузера
      var urlToChange = self.getAttribute(POPUP.dAttrUrl);
      if (urlToChange) {
        POPUP.changePageUrl(urlToChange);
      }
      DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
    };

    /**
     * Все действия, связанные с закрытием всплывашки
     */
    Popup.prototype.popupClose = function () {
      var self = this;
      if (!POPUP.state.opened) {
        return;
      }
      if (activeButton) {
        /* ??? */
        activeButton.classList.remove("js-active");
        activeButton = undefined;
      } /* ??? */

      self.classList.remove(POPUP.openedClass);

      // Так как вплывашка прилетает не мгновенно, а плавно,
      // то сразу делать возврат страницы к исходному состоянию нельзя
      // (будут видны артефакты, сязанные с переводом полосы прокрутки
      // от body к .l-wrapper и обратно).
      var _end = function end() {
        var videoItem = self.querySelector(".js-video-item");
        if (videoItem) {
          itsoftApp.modules.video.videoStop(videoItem);
        }
        setTimeout(function () {
          POPUP.clearScrollStyles();
        }, 200);
        if (transitionEventEnd) {
          self.removeEventListener(transitionEventEnd, _end);
          POPUP.openedPopups.pop();
        }
        POPUP.state.opened = false;
      };

      // Для современных браузеров, где работает свойство transition,
      // вешаем обработчик на событие transitionEnd.
      if (transitionEventEnd) {
        self.addEventListener(transitionEventEnd, _end);

        // Для старых браузеров, сразу вызываем функцию.
      } else {
        _end();
      }

      // При необходимости,
      // меняем (возвращаем обратно)
      // адрес в строке браузера.
      var urlToChange = self.getAttribute(POPUP.dAttrUrl);
      if (urlToChange) {
        POPUP.changePageUrl("back");
      }
      DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
    };

    /**
     * Возврат страницы к исходному
     * (до того, как была открыта хоть одна всплывшка)
     * состоянию.
     *
     * @param  {boolean} force Часть функционала можно исполнить принудительно
     */
    Popup.prototype.clearScrollStyles = function (force) {
      if (force == null) {
        force = false;
      }

      // Функция выполнится, если не осталось открытых всплывашек
      // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
      // либо принудительно (в редких случаях).
      var hasOpenedPopups = POPUP.openedPopups.length > 0;
      if (hasOpenedPopups && !force) {
        return;
      }

      // Вычисляем текущую величину прокрутки страницы
      // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
      // Это нужно сделать до того, как произойдут дальнейшие действия.
      // $wrapper.classList.add(wrapperOverflow);
      var scrTop = getScrTop();
      DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999");
      // $wrapper.classList.remove(wrapperOverflow);
      // Возвращаем структурные элементы .l-wrapper и body
      // к исходному состоянию, убираем все необходимые классы.
      if (module.$wrapper) {
        module.$wrapper.classList.remove(POPUP.wrapperAbsClass);
      }
      $body.classList.remove(POPUP.popupOpenedClass);

      // Если на странице есть fixed элементы,
      // то убираем ранее заданное значение radding-right
      if (hasFixedElems) {
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = "";
        });
      }

      // NOTE: Это из-за плашки browser-update
      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;
      if (mtExists) {
        scrTop += mt;
      }

      // Наконец, пролистываем body до того значения,
      // который был у .l-wrapper.
      // Происходит это довольно быстро, так что пользователь не заметит разницы.
      $document.scrollTop = scrTop;
    };

    /**
     * Обработчик события "click", который определяет,
     * по какому именно мы кликнули элементу, и, если это
     * "пустое пространство" за самой всплывахой,
     * то закрываем её.
     *
     * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
     *
     * @param  {object} e Event
     */
    Popup.prototype.popupClick = function (evt) {
      var self = this;
      if (evt.target === self && self.getAttribute(POPUP.dAttrBgClose) !== "false") {
        self.dispatchEvent(window.closeEvent);
      }
    };

    /**
     * Так как прокрутку страницы мы "отменяем" хитрым способом,
     * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
     * нас перекинет наверх страницы.
     * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
     * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
     * тем самым нас не перекинет наверх после перезагрузки.
     */
    Popup.prototype.windowUnload = function () {
      POPUP.clearScrollStyles(true);
    };
    this.popup.addEventListener(POPUP.evNameOpen, POPUP.popupOpen);
    this.popup.addEventListener(POPUP.evNameClose, POPUP.popupClose);
    this.popup.addEventListener("click", POPUP.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.addEventListener("click", POPUP.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.addEventListener("click", POPUP.closePopupBtnClick);
    });
    if (this.popup.getAttribute("data-bg-opened") == "true") {
      var dAttrSave = this.popup.getAttribute("data-save");
      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(this.popup)) {
        this.popup.dispatchEvent(window.openEvent);
        DEBUG && console.log("data-bg open event");
      } else if (!dAttrSave) {
        this.popup.dispatchEvent(window.openEvent);
        DEBUG && console.log("data-bg else open event");
      } else {
        this.popup.dispatchEvent(window.closeEvent);
      }
    }
    if (!this.state.initedExemplar) {
      this.state.initedExemplar = true;
    }
  };
  // Перемещаем все всплывашки в конец <body>.
  // Это нужно для того, чтобы при открытии всплывашки,
  // событие "scroll" всплывало до <body> и <html>,
  // но НЕ всплывало до <div class="l-wrapper">.
  // Это важно, так как при открытии всплывашки прокрутка
  // убирается у <body> и появляется у <div class="l-wrapper">.
  // Тем самым, мы "отменяем скролл".
  //
  // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
  // (иначе не было бы всей этой истории).
  // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
  // Но ряд событий отменить или прервать всплытие нельзя.

  /**
   * Изменение адресной строки браузера при открытии всплывашки
   * (по необходимости).
   * Доп. инфа:
   * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
   *
   * @param  {string} url     Новый адрес
   * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
   */
  Popup.prototype.changePageUrl = function (url) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    }

    // Переход "вперёд" по истории браузера ...
    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      this.globalState.historyPushed = true;

      // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (this.globalState.historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back();

        // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof this.popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - this.popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };
  Array.prototype.forEach.call(popups, function (popup) {
    new Popup(popup);
  });
  module.callback = {
    popup: Popup
  };
});
"use strict";

/**
 * Дисклеймер подвала «БАД. Не является лекарственным средством. Необходима
 * консультация специалиста» — в одну строку во всю ширину, кегль по доле
 * площади экрана (заказчик, 19–21.10.2026: одна строка, шрифт из макета,
 * 10% для БАДа по рамкам букв).
 *
 * Разметка — include/views/footer-disclaimer.php:
 *
 *   <div class="footer-disclaimer__text js-disclaimer-fit"
 *        data-ratio="0.1" data-mode="bbox"
 *        data-min-scale-x="0.05" data-max-scale-y="1">БАД. …</div>
 *
 * Порог и трактовка площади живут в атрибутах, расчёт — общий модуль
 * `disclaimerFit` (template). Здесь только привязка: обёртка `__text-inner`
 * (на неё идёт scaleX), кегль из CSS как нижняя граница (на 1440 — макетные
 * 128.25), пересчёт на ресайзе и после загрузки шрифта.
 */
itsoftApp.createModule("regulatoryDisclaimer", ["disclaimerFit"], function () {
  var module = this;

  // Второй проход после ресайза: бокс ещё старый в момент события
  // (поворот телефона, панель адреса), см. скилл itsoft-disclaimer.
  var RESIZE_SETTLE_MS = 350;
  var RESIZE_DEBOUNCE_MS = 100;
  var RegulatoryDisclaimer = function RegulatoryDisclaimer() {
    this.items = Array.prototype.slice.call(document.querySelectorAll(".js-disclaimer-fit"));
    if (!this.items.length) {
      return;
    }
    this.fitApi = itsoftApp.modules.disclaimerFit.callback;
    this.timers = [];
    this.items.forEach(this.prepare, this);
    this.init();
  };

  /* Текст лежит прямо в элементе — заворачиваем его в обёртку для transform */
  RegulatoryDisclaimer.prototype.prepare = function (textEl) {
    if (!textEl.querySelector("[class$='__text-inner']")) {
      var inner = document.createElement("span");
      inner.className = textEl.classList[0] + "-inner";
      while (textEl.firstChild) {
        inner.appendChild(textEl.firstChild);
      }
      textEl.appendChild(inner);
    }

    /* С этим классом CSS держит строку одной (без JS текст переносится) */
    textEl.classList.add("_fit");
  };
  RegulatoryDisclaimer.prototype.fitItem = function (textEl) {
    var inner = textEl.querySelector("[class$='__text-inner']");

    /* Кегль из CSS — нижняя граница: снимаем инлайн прошлого прогона */
    textEl.style.fontSize = "";
    var minSize = parseFloat(window.getComputedStyle(textEl).fontSize) || 0;
    var result = this.fitApi.fit(textEl, inner, {
      ratio: parseFloat(textEl.getAttribute("data-ratio")) || 0.05,
      mode: textEl.getAttribute("data-mode") || "bbox",
      sxMin: parseFloat(textEl.getAttribute("data-min-scale-x")) || 0.7,
      syMax: parseFloat(textEl.getAttribute("data-max-scale-y")) || 1.5,
      singleLine: true,
      minSize: minSize
    });

    /* Высота надписи изменилась — слушает disclaimerFloat.js */
    if (typeof window.CustomEvent === "function") {
      textEl.dispatchEvent(new CustomEvent("disclaimer:fit", {
        bubbles: true
      }));
    }
    DEBUG && result && console.log("[module regulatoryDisclaimer] " + result.size.toFixed(2) + "px, scale " + result.scaleX.toFixed(3) + "×" + result.scaleY.toFixed(3) + ", доля " + (result.coverage * 100).toFixed(2) + "% (" + result.mode + ")" + (result.wrapped ? ", перенос" : ""));
    return result;
  };
  RegulatoryDisclaimer.prototype.fitAll = function () {
    this.items.forEach(this.fitItem, this);
  };
  RegulatoryDisclaimer.prototype.onResize = function () {
    var self = this;
    this.timers.forEach(window.clearTimeout);
    this.timers = [window.setTimeout(function () {
      self.fitAll();
    }, RESIZE_DEBOUNCE_MS), window.setTimeout(function () {
      self.fitAll();
    }, RESIZE_SETTLE_MS)];
  };
  RegulatoryDisclaimer.prototype.onFontsLoaded = function () {
    /* Первые замеры могли лечь с метриками запасного шрифта */
    this.fitApi.invalidateCache();
    this.fitAll();
  };
  RegulatoryDisclaimer.prototype.init = function () {
    var self = this;
    this.fitAll();
    window.addEventListener("resize", function () {
      self.onResize();
    });
    if (document.fonts) {
      if (document.fonts.ready) {
        document.fonts.ready.then(function () {
          self.onFontsLoaded();
        });
      }
      if (document.fonts.addEventListener) {
        document.fonts.addEventListener("loadingdone", function () {
          self.onFontsLoaded();
        });
      }
    }
  };
  module.instance = new RegulatoryDisclaimer();
  module.callback = RegulatoryDisclaimer;
});
"use strict";

itsoftApp.createModule("saveCookies", function () {
  var saveCookieButtons = document.querySelectorAll(".js-save-button");
  var cookies = document.querySelector(".js-cookies");
  var bodyEnd = document.querySelector(".js-padding-bottom");
  window.cookiesState = "inactive";
  var saveCookie = function saveCookie(evt) {
    evt.preventDefault();
    var button = evt.currentTarget;
    if (button.hasAttribute("data-close")) {
      var plate = button.closest("[data-plate=" + button.getAttribute("data-close") + "]");
      plate && plate.classList.add("is-hidden");
    }
    itsoftApp.modules.cookie.setCookie(button);
    window.cookiesState = "inactive";
    bodyEnd.style.paddingBottom = 0;
  };
  if (saveCookieButtons.length > 0) {
    window.cookiesState = "active";
    bodyEnd.style.paddingBottom = cookies.getBoundingClientRect().height + "px";
    Array.prototype.forEach.call(saveCookieButtons, function (button) {
      button.addEventListener("click", saveCookie);
    });
  }
});
"use strict";

itsoftApp.createModule("scrollTo", ["windowResize", "startLoad"], function () {
  var module = this;
  var hash = location.hash;
  var hashElement = hash ? document.querySelector(hash) : null;
  var ResponsiveScroll = function ResponsiveScroll() {
    this.duration = 1;
    this.init();
  };

  /*
   * Высота шапки, которая лежит ПОВЕРХ страницы. На боевом шаблоне (Bitrix,
   * cartilox.itsft.ru) шапка #header сначала absolute, а после прокрутки
   * получает класс .fixed и прилипает к верху — с нулевым отступом она
   * закрывала верх блока, и казалось, что прокрутка «проезжает» дальше.
   * Локально шапки нет — отступ 0.
   */
  var getHeaderOffset = function getHeaderOffset() {
    var header = document.querySelector(".js-header, #header, header.header, .page-header");
    if (!header) {
      return 0;
    }
    var position = window.getComputedStyle(header).position;
    if (position !== "fixed" && position !== "absolute" && position !== "sticky") {
      return 0;
    }
    return header.offsetHeight;
  };
  ResponsiveScroll.prototype.scrollTo = function (hash, extraOffset) {
    var RESPONSIVE_SCROLL = this;
    var wrapper = document.querySelector('.l-wrapper');
    var wrapperCurHeight = wrapper.clientHeight;
    var delayCheck = RESPONSIVE_SCROLL.duration * 1000 / 2;
    var doScroll = function doScroll() {
      gsap.to(window, {
        duration: RESPONSIVE_SCROLL.duration,
        scrollTo: {
          y: hash,
          offsetY: getHeaderOffset() + (extraOffset || 0)
        }
      });
    };
    doScroll();

    // setTimeout(() => {
    //     // В середине прокрутки проверяем, не изменилась ли высота у страницы,
    //     //  т.к есть ленивая загрузка скриптов и контент может прыгать, 
    //     // из-за этого может не доскролить до блока
    //     // если изменилась, скроллим еще раз
    //     if (wrapperCurHeight !== wrapper.clientHeight) {
    //         doScroll();
    //     }
    // }, delayCheck);
  };
  ResponsiveScroll.prototype.onLinkClick = function (evt) {
    evt.preventDefault();
    var RESPONSIVE_SCROLL = this;
    var target = evt.currentTarget;
    var hash = target.getAttribute("href");
    var extraOffset = 0;
    if (!itsoftApp.libraries.scrollToPlugin.loaded) {
      // console.log(itsoftApp.libraries.scrollToPlugin.loaded, ' if')
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(hash, extraOffset);
      }, itsoftApp.libraries.scrollToPlugin);
    } else {
      RESPONSIVE_SCROLL.scrollTo(hash, extraOffset);
      // console.log(itsoftApp.libraries.scrollToPlugin.loaded, ' else')
    }
  };
  ResponsiveScroll.prototype.init = function () {
    var RESPONSIVE_SCROLL = this;

    /*
     * На Bitrix сборка с 23.10.2026 грузится на всех страницах (шапка), а у страниц
     * старого шаблона нет .l-wrapper: там модуль отменял переход по любому якорю
     * («Подробнее» → #videos на /exercise) и падал на wrapper.clientHeight. На них
     * якоря работают как раньше — переходом браузера и обработчиками main-new.js.
     */
    if (!document.querySelector(".l-wrapper")) {
      return;
    }
    if (hash && hashElement) {
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(hash);
      }, itsoftApp.libraries.scrollToPlugin);
    }
    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (link) {
      // const clickedScrollFlag = true;
      link.addEventListener("click", RESPONSIVE_SCROLL.onLinkClick.bind(RESPONSIVE_SCROLL));
    });
  };
  itsoftApp.modules.pageLoad.addEvent(function () {
    new ResponsiveScroll();
  });
  module.callback = ResponsiveScroll;
});
"use strict";

itsoftApp.createModule("slidersLibrary", function () {
  var module = this;
  var Slider = function Slider(el, sliderSettings, cb, currentSlide) {
    this.el = el;
    this.sliderSettings = sliderSettings;
    this.currentSlide = currentSlide;
    this.sliderContainer = el.querySelector(".swiper-container");
    this.navigation = el.querySelector(".swiper-navigation");
    this.pagination = el.querySelector(".swiper-pagination");
    this.scrollbar = el.querySelector(".swiper-scrollbar");
    this.dataDevice = el.getAttribute("data-destroy-device");
    this.destroyDirection = el.getAttribute("data-destroy-direction");
    this.withoutNavigation = el.hasAttribute("data-without-navigation");
    this.withoutPagination = el.hasAttribute("data-without-pagination");
    this.isInitialized = false;
    this.initializedSlider = null;
    this.init();
  };
  Slider.prototype.init = function () {
    var SLIDER = this;
    var outerNavName = SLIDER.sliderContainer.getAttribute("data-slider-name") || SLIDER.sliderSettings.sliderName || "";
    SLIDER.outerNavigation = document.querySelector("[data-slider-nav='" + outerNavName + "']");
    Slider.prototype.onWindowResize = function () {
      var SLIDER = this;
      if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else {
        if (SLIDER.isInitialized === false) {
          SLIDER.initSlider();
          DEBUG && console.log("init", ' ' + outerNavName);
        }
      }
    };
    Slider.prototype.createSlider = function () {
      if (!SLIDER.sliderSettings) {
        return;
      }
      if (!SLIDER.withoutNavigation && (SLIDER.navigation || SLIDER.outerNavigation)) {
        var prevBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-prev-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-prev-btn");
        var nextBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-next-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-next-btn");
        SLIDER.sliderSettings.navigation = {};
        SLIDER.sliderSettings.navigation.prevEl = prevBtn;
        SLIDER.sliderSettings.navigation.nextEl = nextBtn;
      }
      if (!SLIDER.withoutPagination && SLIDER.pagination) {
        if (!SLIDER.sliderSettings.pagination) {
          SLIDER.sliderSettings.pagination = {};
        }
        SLIDER.sliderSettings.pagination.el = SLIDER.pagination;
        if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
          SLIDER.sliderSettings.pagination.type = "bullets";
          SLIDER.sliderSettings.pagination.clickable = true;
        } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
          SLIDER.sliderSettings.pagination.type = "progressbar";
          // SLIDER.sliderSettings.pagination.clickable = true;
        } else {
          SLIDER.sliderSettings.pagination.type = "fraction";
          SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
            return "<span class='" + currentClass + "'></span>" + "/" + "<span class='" + totalClass + "'></span>";
          };
        }
      }
      if (SLIDER.scrollbar) {
        var scrollbar = SLIDER.el.querySelector(".swiper-scrollbar");
        SLIDER.sliderSettings.scrollbar = {};
        SLIDER.sliderSettings.scrollbar.el = scrollbar;
        SLIDER.sliderSettings.scrollbar.draggable = true;
      }
      if (SLIDER.dataDevice) {
        SLIDER.onWindowResize.call(SLIDER);
        itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize.bind(SLIDER)); // TODO: проверить this
      } else {
        SLIDER.initSlider();
      }
    };
    new itsoftApp.modules.startLoad.callback(this.createSlider, itsoftApp.libraries.slider);
  };
  Slider.prototype.destroySlider = function () {
    this.initializedSlider.destroy(false, true);
    this.initializedSlider = undefined;
    this.isInitialized = false;
  };
  Slider.prototype.initSlider = function () {
    this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);
    if (this.initializedSlider) {
      if (this.currentSlide) {
        this.initializedSlider.slideTo(+this.currentSlide);
      }
      this.isInitialized = true;
    }
  };
  module.callback = Slider;
});
"use strict";

/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  var module = this;
  var Settings = {
    global: {
      slidesPerView: "auto",
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      }
    },
    problems: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    banner: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    // Баннеры мобильного меню (header-main.php): по одному на экран, точки —
    // js-pagination-dots; создаётся из mobMenu.js при первом открытии меню
    menuBanner: {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      }
    },
    articles: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      // simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    brands: {
      slidesPerView: "auto",
      freeModeMomentum: false,
      speed: 500,
      simulateTouch: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var slider = swiperContainer.closest('.js-slider');
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            slider: slider,
            sliderName: sliderName
          };
          var customParams = swiper.params.custom;
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    }
  };
  var getSettings = function getSettings(slidersSettingsKey) {
    return Settings[slidersSettingsKey];
  };
  module.getSettings = getSettings;
});
"use strict";

itsoftApp.createModule("startLoad", ["pageLoad"], function () {
  var module = this;
  var LibraryLoader = function LibraryLoader(func, library) {
    this.func = func;
    this.library = library;
    this.startLoad();
  };
  LibraryLoader.prototype.initQueue = function () {
    var LIBRARY_LOADER = this;
    if (!LIBRARY_LOADER.library.loaded) {
      return false;
    }
    if (!LIBRARY_LOADER.library.queue.length) {
      return;
    }
    DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] initQueue function fired, queue.length: " + LIBRARY_LOADER.library.queue.length);
    while (LIBRARY_LOADER.library.queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      LIBRARY_LOADER.library.queue.shift()();
    }
  };
  LibraryLoader.prototype.loadScriptStart = function (f) {
    var LIBRARY_LOADER = this;
    itsoftApp.loadScript(LIBRARY_LOADER.library.script, function () {
      DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] library loaded, ready to init queue");
      f();
    });
  };
  LibraryLoader.prototype.loadAndInit = function () {
    var LIBRARY_LOADER = this;
    var f = function f() {
      if (!LIBRARY_LOADER.library.loaded && LIBRARY_LOADER.library.cb && typeof LIBRARY_LOADER.library.cb === "function") {
        LIBRARY_LOADER.library.cb();
      }
      LIBRARY_LOADER.library.loaded = true;
      LIBRARY_LOADER.initQueue();
    };
    if (LIBRARY_LOADER.library.hasOwnProperty("style")) {
      itsoftApp.loadStyle(LIBRARY_LOADER.library.style);
    }
    if (LIBRARY_LOADER.library.hasOwnProperty("dependency") && LIBRARY_LOADER.library.dependency) {
      new itsoftApp.modules.startLoad.callback(function () {
        LIBRARY_LOADER.loadScriptStart(f);
      }, itsoftApp.libraries[LIBRARY_LOADER.library.dependency]);
    } else {
      LIBRARY_LOADER.loadScriptStart(f);
    }
  };
  LibraryLoader.prototype.addEvent = function () {
    var LIBRARY_LOADER = this;
    if (typeof this.func !== "function") {
      return;
    }

    // Если библиотека ещё не загружена, то добавляем в очередь
    if (!this.library.loaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!this.library.started) {
        this.library.started = true;
        DEBUG && console.log("%c--[module" + this.library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(function () {
          LIBRARY_LOADER.loadAndInit();
        });
      }
      this.library.queue.push(this.func);
      DEBUG && console.log("[module " + this.library.name + "] function added, count of functions to init now: " + this.library.queue.length);

      // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      this.func();
    }
  };
  LibraryLoader.prototype.startLoad = function () {
    this.addEvent(this.func);
  };

  // Доступ к функциям
  // текущего модуля
  module.callback = LibraryLoader;
});
"use strict";

/**
 * Блок «Компоненты Картилокс Т» на странице /cartilox-t/.
 *
 * Сам аккордеон — общий модуль accordion (js-accordion / js-accordion-item).
 * Этот модуль отвечает за две вещи:
 *   1) левая колонка на десктопе: пока всё закрыто, там заголовок; как только
 *      пункт раскрывают — вместо заголовка появляется картинка компонента;
 *   2) плавный сдвиг названия пункта (FLIP). В раскрытом пункте по макету нет
 *      цифры, и её место освобождается мгновенно (иначе название в переходном
 *      состоянии не влезает в строку) — название прыгало влево на ширину цифры.
 *      Здесь мы замеряем сдвиг и гасим его transform'ом, а CSS-переход
 *      (.t-components__name { transition: transform }) доводит его до нуля.
 *
 * Хуки — data-атрибуты и js-классы, чтобы не зависеть от БЭМ-имён.
 */
itsoftApp.createModule("tComponents", ["windowResize"], function () {
  var module = this;
  var TComponents = function TComponents(container) {
    if (!container) {
      return;
    }
    this.container = container;
    this.items = container.querySelectorAll(".js-accordion-item");
    this.images = container.querySelectorAll(".js-t-components-img");
    this.classNames = {
      active: "_active",
      mediaActive: "_media-active",
      itemActive: "js-accordion-item--active"
    };
    this.init();
  };
  TComponents.prototype.init = function () {
    var self = this;
    Array.prototype.forEach.call(this.items, function (item) {
      var head = item.querySelector(".js-accordion-head");
      self.watchName(item);
      if (!head) {
        return;
      }

      /*
       * aria-expanded у кнопки шапки — по классу пункта: раскрывает его
       * общий модуль accordion, поэтому следим за классами, а не за кликом
       */
      var syncExpanded = function syncExpanded() {
        head.setAttribute("aria-expanded", item.classList.contains(self.classNames.itemActive) ? "true" : "false");
      };
      new MutationObserver(syncExpanded).observe(item, {
        attributes: true,
        attributeFilter: ["class"]
      });
      syncExpanded();
      head.addEventListener("click", function () {
        /* Клик по уже раскрытому пункту закрывает его — тогда возвращаем заголовок */
        if (item.classList.contains(self.classNames.itemActive)) {
          self.setImage(null);
          return;
        }
        self.setImage(item.getAttribute("data-component"));
      });
    });
    var refresh = this.refreshNames.bind(this);
    this.container.addEventListener("click", refresh, true);
    this.container.addEventListener("transitionend", refresh, true);
    itsoftApp.modules.windowResize.addEvent(refresh);
    var opened = this.container.querySelector("." + this.classNames.itemActive);
    this.setImage(opened ? opened.getAttribute("data-component") : null);
  };

  /**
   * Положение названия внутри пилюли. Берём offsetLeft/offsetTop, а не
   * getBoundingClientRect: они не зависят ни от прокрутки, ни от transform,
   * который в этот момент может ещё доигрывать с прошлого переключения.
   */
  var nameOffset = function nameOffset(name) {
    return {
      x: name.offsetLeft,
      y: name.offsetTop
    };
  };

  /**
   * FLIP: смена классов аккордеона мгновенно переносит название на новое
   * место, поэтому в тот же кадр возвращаем его трансформом назад и сразу
   * отпускаем — CSS-переход доводит его плавно.
   */
  TComponents.prototype.watchName = function (item) {
    var name = item.querySelector(".t-components__name");
    if (!name || typeof MutationObserver === "undefined") {
      return;
    }
    item.nameFlip = {
      name: name,
      offset: nameOffset(name)
    };
    var observer = new MutationObserver(function () {
      var flip = item.nameFlip;
      var next = nameOffset(name);
      var shiftX = flip.offset.x - next.x;
      var shiftY = flip.offset.y - next.y;
      flip.offset = next;
      if (Math.abs(shiftX) < 1 && Math.abs(shiftY) < 1) {
        return;
      }
      name.style.transition = "none";
      name.style.transform = "translate(" + shiftX + "px, " + shiftY + "px)";

      /* Принудительный пересчёт: без него обе правки схлопнутся в одну и перехода не будет */
      name.getBoundingClientRect();
      name.style.transition = "";
      name.style.transform = "";
    });
    observer.observe(item, {
      attributes: true,
      attributeFilter: ["class"]
    });
  };

  /**
   * Обновить базу FLIP у всех пунктов.
   *
   * Кэшировать её один раз на старте нельзя: пока грузится шрифт, метрики
   * названия меняются, и первое же раскрытие уезжает на разницу. Поэтому
   * базу снимаем прямо перед тем, как общий модуль аккордеона переставит
   * классы, — в фазе ПЕРЕХВАТА, до его собственных обработчиков:
   * `click` — раскрытие, `transitionend` — закрытие (в том числе соседнего
   * пункта, по которому не кликали).
   */
  TComponents.prototype.refreshNames = function () {
    Array.prototype.forEach.call(this.items, function (item) {
      if (item.nameFlip) {
        item.nameFlip.offset = nameOffset(item.nameFlip.name);
      }
    });
  };
  TComponents.prototype.setImage = function (key) {
    var self = this;
    Array.prototype.forEach.call(this.images, function (image) {
      var isActive = key !== null && image.getAttribute("data-component") === key;
      image.classList.toggle(self.classNames.active, isActive);
    });
    this.container.classList.toggle(this.classNames.mediaActive, key !== null);
    DEBUG && console.log("[module tComponents] active component: " + key);
  };

  /*
   * Заголовок блока покрашен градиентом через background-clip: text. Маска
   * клипа — это глифы ВСЕХ потомков, их filter/opacity она не учитывает,
   * поэтому пословная анимация (animateTitle оборачивает слова в <i> с
   * blur + opacity) была не видна: слова горели сразу. После разбивки
   * градиент переезжает на каждое слово (CSS: .t-components__title._show),
   * а здесь ему задаётся размер всего заголовка и сдвиг на позицию слова —
   * так картинка совпадает с прежней, общей на заголовок.
   */
  var paintTitleWords = function paintTitleWords(title) {
    var words = title.querySelectorAll("i");
    if (!words.length) {
      return;
    }
    var size = title.offsetWidth + "px " + title.offsetHeight + "px";
    Array.prototype.forEach.call(words, function (word) {
      word.style.backgroundSize = size;
      word.style.backgroundPosition = -word.offsetLeft + "px " + -word.offsetTop + "px";
    });
  };
  var initTitle = function initTitle(title) {
    var repaint = function repaint() {
      paintTitleWords(title);
    };

    // слова появляются, когда animateTitle ставит _show
    new MutationObserver(repaint).observe(title, {
      childList: true
    });
    itsoftApp.modules.windowResize.addEvent(repaint);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(repaint);
    }
    repaint();
  };
  var initTComponents = function initTComponents() {
    var containers = document.querySelectorAll(".js-t-components");
    Array.prototype.forEach.call(containers, function (el) {
      if (!el.tComponents) {
        el.tComponents = new TComponents(el);
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll(".js-t-components-title"), initTitle);
  };
  initTComponents();
  module.callback = TComponents;
});
"use strict";

itsoftApp.createModule("video", function () {
  var module = this;
  var videoItemEls = document.querySelectorAll(".js-video-item");
  var videoEls = document.querySelectorAll("video");
  if (videoEls.length > 0) {
    videoEls.forEach(function (videoEl) {
      videoEl.setAttribute("controlslist", "nodownload");
    });
  }
  var initVideo = function initVideo(videoEl) {
    var videoBlockWrapper = videoEl.querySelector(".js-video-container");
    var videoItem = videoEl.querySelector(".js-video-item");
    var playButtons = videoEl.querySelectorAll(".js-button-play");
    var onVideoPlay = function onVideoPlay() {
      videoItem.onplay = function () {
        videoItemEls.forEach(function (el) {
          if (el === videoItem) {
            videoItem.play();
          } else {
            el.pause();
          }
        });
      };
      videoItem.play();
      videoEl.classList.add("js-inited");
      videoItem.classList.add("js-active");
      videoBlockWrapper.classList.add("js-active");
    };
    playButtons.forEach(function (playButton) {
      playButton.addEventListener("click", onVideoPlay);
    });
  };
  var videoPlay = function videoPlay(videoItem) {
    videoItem.play();
  };
  var videoStop = function videoStop(videoItem) {
    videoItem.pause();
  };
  module.initVideo = initVideo;
  module.videoPlay = videoPlay;
  module.videoStop = videoStop;
});
"use strict";

/**
 * Ролик секции: стартует, когда блок доскроллили до экрана.
 *
 * Перенесён из template (videoInView.js) и дополнен под /cartilox-t/:
 *   • «Многокомпонентный состав» — таблетка раскрывается и остаётся в конечном
 *     кадре (без loop); при каждом возвращении в блок — заново (watchReplay);
 *   • «Нутриентная поддержка» — волокно бесконечно (loop); за кадром — пауза,
 *     чтобы зацикленный ролик не держал декодер и батарею.
 *
 * Разметка:
 *   <div class="js-video-in-view" data-lazy-function="videoInView">
 *       <video data-video-in-view muted playsinline preload="none" poster="…"
 *              [loop] [data-reveal-at="2.2"] [data-src-mob="…-mob.mp4"]>
 *           <source src="…" type="video/mp4">
 *       </video>
 *   </div>
 *
 * Загрузка начинается за экран до блока (watchApproach), одноразовый ролик
 * стартует только скачанным целиком (whenReady) — иначе на мобильной сети он
 * замирал посреди анимации.
 *
 * Запуск — отдельный экземпляр vanilla-lazyload (lazyLoading.js, класс
 * `js-video-in-view`, порог −150: ролик начинается, когда блок уже на экране,
 * а не за 300px до него, как у общего `.js-script`).
 *
 * `data-reveal-at` (секунды) — с этого момента ближайший `[data-video-host]`
 * получает `is-video-revealed`: так на таблетке появляются круг «9» и подпись,
 * которые в первых кадрах легли бы поверх ещё целой капсулы. Если ролик не
 * сыграет (отказ автоплея, prefers-reduced-motion), ролик ставится на
 * последний кадр и подписи открываются сразу — блок выглядит как статичный
 * макет.
 *
 * Автоплей без звука на iOS — только с `muted` и `playsinline`. play() может
 * быть отклонён (режим энергосбережения, настройка сайта): тогда повтор через
 * 1.2 с и на первое касание/клик, если ролик в кадре (подробно — template,
 * docs/video.md).
 */
itsoftApp.createModule("videoInView", function () {
  var module = this;
  var PLAYED_CLASS = "is-played";
  var REVEALED_CLASS = "is-video-revealed";
  var hostOf = function hostOf(video) {
    return video.closest("[data-video-host]");
  };
  var setRevealed = function setRevealed(video, state) {
    var host = hostOf(video);
    if (host) {
      host.classList.toggle(REVEALED_CLASS, state);
    }
  };

  /* Подписи по времени ролика */
  var watchReveal = function watchReveal(video) {
    var at = parseFloat(video.getAttribute("data-reveal-at"));
    if (!(at >= 0) || video.dataset.revealWatched) {
      return;
    }
    video.dataset.revealWatched = "1";
    var check = function check() {
      setRevealed(video, video.currentTime >= at || video.ended);
    };
    video.addEventListener("timeupdate", check);
    video.addEventListener("ended", check);
    video.addEventListener("seeked", check);
  };

  /* Конечное состояние без воспроизведения: последний кадр + подписи */
  var showFinalState = function showFinalState(video) {
    setRevealed(video, true);
    if (video.loop) {
      return;
    }
    var seekToEnd = function seekToEnd() {
      if (video.duration && isFinite(video.duration)) {
        video.currentTime = Math.max(video.duration - 0.05, 0);
      }
    };
    if (video.readyState >= 1) {
      seekToEnd();
    } else {
      video.addEventListener("loadedmetadata", seekToEnd, {
        once: true
      });
    }
  };
  var watchVisibility = function watchVisibility(video) {
    if (!window.IntersectionObserver || video.dataset.visibilityWatched) {
      return;
    }
    video.dataset.visibilityWatched = "1";
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          var resumed = video.play();
          if (resumed && typeof resumed["catch"] === "function") {
            resumed["catch"](function () {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      }
    }, {
      rootMargin: "10% 0px"
    });
    observer.observe(video);
  };
  var reducedMotion = function reducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  };

  /* Мобильная версия файла (`data-src-mob`) — ниже планшета. Выбираем до
     load(): `media` у <source> поддержан не везде */
  var MOB_QUERY = "(max-width: 767px)";
  var chooseSource = function chooseSource(video) {
    var mob = video.getAttribute("data-src-mob");
    var source = video.querySelector("source");
    if (mob && source && window.matchMedia && window.matchMedia(MOB_QUERY).matches) {
      source.src = mob;
    }
  };

  /* Начать загрузку (один раз): preload="none" в разметке — до подхода к
     блоку трафик не тратим */
  var prime = function prime(video) {
    if (video.dataset.primed) {
      return;
    }
    video.dataset.primed = "1";
    chooseSource(video);
    video.preload = "auto";
    video.load();
  };

  /* Загрузка заранее — примерно за экран до блока. Ролик в 4 с при 6 Мбит/с
     на мобильной сети начинал играть недогруженным и замирал посреди
     анимации (замер 23.10.2026: на 4 Мбит/с — 2 остановки, 7.1 с вместо 4) */
  var watchApproach = function watchApproach() {
    var videos = document.querySelectorAll("[data-video-in-view]");
    if (!videos.length) {
      return;
    }
    if (!window.IntersectionObserver) {
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          observer.unobserve(entries[i].target);
          if (!reducedMotion()) {
            prime(entries[i].target);
          }
        }
      }
    }, {
      rootMargin: "100% 0px"
    });
    for (var i = 0; i < videos.length; i += 1) {
      observer.observe(videos[i]);
    }
  };

  /* Одноразовый ролик стартует, когда скачан ЦЕЛИКОМ: короткую анимацию
     нельзя останавливать на догрузку. Не дождались за READY_TIMEOUT —
     играем как есть (лучше рывок, чем вечный постер) */
  var READY_TIMEOUT = 8000;
  var fullyBuffered = function fullyBuffered(video) {
    var b = video.buffered;
    return video.readyState >= 4 && b.length > 0 && video.duration > 0 && b.end(b.length - 1) >= video.duration - 0.1;
  };
  var whenReady = function whenReady(video, fn) {
    if (video.loop || fullyBuffered(video)) {
      fn();
      return;
    }
    var done = false;
    var finish = function finish() {
      if (done) {
        return;
      }
      done = true;
      video.removeEventListener("progress", check);
      video.removeEventListener("canplaythrough", check);
      window.clearTimeout(timer);
      fn();
    };
    var check = function check() {
      if (fullyBuffered(video)) {
        finish();
      }
    };
    var timer = window.setTimeout(finish, READY_TIMEOUT);
    video.addEventListener("progress", check);
    video.addEventListener("canplaythrough", check);
  };
  var pending = [];
  var gestureBound = false;
  var inViewport = function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0);
  };
  var _tryPending = function tryPending() {
    var _loop = function _loop() {
      var video = pending[i];
      if (!inViewport(video)) {
        return 1; // continue
      }

      /* Одноразовый ролик после отказа стоит на последнем кадре —
         запускаем его сначала, подписи снова ждут своей секунды */
      if (!video.loop) {
        video.currentTime = 0;
        setRevealed(video, false);
      }
      var resumed = video.play();
      if (resumed && typeof resumed.then === "function") {
        resumed.then(function () {
          var idx = pending.indexOf(video);
          if (idx !== -1) {
            pending.splice(idx, 1);
          }
        })["catch"](function () {
          showFinalState(video);
        });
      }
    };
    for (var i = pending.length - 1; i >= 0; i -= 1) {
      if (_loop()) continue;
    }
    if (!pending.length && gestureBound) {
      document.removeEventListener("touchstart", _tryPending);
      document.removeEventListener("click", _tryPending);
      gestureBound = false;
    }
  };
  var retryLater = function retryLater(video) {
    if (pending.indexOf(video) === -1) {
      pending.push(video);
    }
    window.setTimeout(_tryPending, 1200);
    if (!gestureBound) {
      document.addEventListener("touchstart", _tryPending, {
        passive: true
      });
      document.addEventListener("click", _tryPending);
      gestureBound = true;
    }
  };
  var start = function start(video) {
    whenReady(video, function () {
      var started = video.play();
      if (started && typeof started["catch"] === "function") {
        started["catch"](function (err) {
          DEBUG && console.log("videoInView: автоплей отклонён — " + err.name);
          showFinalState(video);
          retryLater(video);
        });
      }
    });
  };

  /**
   * Одноразовый ролик — заново при каждом возвращении в блок (менеджер,
   * 23.10.2026). Ушёл из кадра целиком — пауза и перемотка в начало
   * (подписи прячутся, пока их не видно); вернулся на те же 150px, что и
   * при первом запуске (порог LazyLoad), — играет с начала.
   */
  var watchReplay = function watchReplay(video) {
    if (!window.IntersectionObserver || video.loop || video.dataset.replayWatched) {
      return;
    }
    video.dataset.replayWatched = "1";
    var armed = false;
    var leave = new IntersectionObserver(function (entries) {
      if (entries[entries.length - 1].isIntersecting) {
        return;
      }
      var idx = pending.indexOf(video);
      if (idx !== -1) {
        pending.splice(idx, 1);
      }
      video.pause();
      if (video.readyState >= 1) {
        video.currentTime = 0;
      }
      setRevealed(video, false);
      armed = true;
    });
    var enter = new IntersectionObserver(function (entries) {
      if (!armed || !entries[entries.length - 1].isIntersecting) {
        return;
      }
      armed = false;
      start(video);
    }, {
      rootMargin: "-150px 0px"
    });
    leave.observe(video);
    enter.observe(video);
  };

  /**
   * @param {Element} root — контейнер с data-lazy-function либо сам <video>.
   */
  var play = function play(root) {
    var video = root.tagName === "VIDEO" ? root : root.querySelector("[data-video-in-view]");
    if (!video || video.classList.contains(PLAYED_CLASS)) {
      return;
    }
    video.classList.add(PLAYED_CLASS);
    video.muted = true;
    video.playsInline = true;
    watchReveal(video);
    if (reducedMotion()) {
      DEBUG && console.log("videoInView: prefers-reduced-motion — конечный кадр без анимации");
      prime(video);
      showFinalState(video);
      return;
    }

    /* Обычно загрузка уже идёт — её начал watchApproach за экран до блока */
    prime(video);
    start(video);
    if (video.loop) {
      watchVisibility(video);
    } else {
      watchReplay(video);
    }
  };
  watchApproach();

  /* После подмены контента страницы (chooseProduct.js) — заново по новым роликам */
  module.refresh = watchApproach;
  module.callback = play;
  module.play = play;
});
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;
  var pageHeader = document.querySelector("[data-fixed='true']");

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */
  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }
    var f, i, len;
    if (pageHeader) {
      itsoftApp.utils.getHeaderHeight();
    }
    itsoftApp.utils.getViewportSize();
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }
    events.push(func);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
  };

  // Привязка события и обработчика
  $window.addEventListener("resize", resizeController);

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */
  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }
    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };

  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */
  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }
    if (!enabled) {
      enabled = true;
      bind();
    }
    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});